/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://dh-static.mesos.nrk.no/stille-spesial/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return h; });
/* unused harmony export createElement */
/* unused harmony export cloneElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return render; });
/* unused harmony export rerender */
/* unused harmony export options */
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/** Virtual DOM Node */
function VNode() {}
/** Global options
 *	@public
 *	@namespace options {Object}
 */


var options = {
  /** If `true`, `prop` changes trigger synchronous component updates.
   *	@name syncComponentUpdates
   *	@type Boolean
   *	@default true
   */
  //syncComponentUpdates: true,

  /** Processes all created VNodes.
   *	@param {VNode} vnode	A newly-created VNode to normalize/process
   */
  //vnode(vnode) { }

  /** Hook invoked after a component is mounted. */
  // afterMount(component) { }

  /** Hook invoked after the DOM is updated with a component's latest render. */
  // afterUpdate(component) { }

  /** Hook invoked immediately before a component is unmounted. */
  // beforeUnmount(component) { }
};
var stack = [];
var EMPTY_CHILDREN = [];
/** JSX/hyperscript reviver
*	Benchmarks: https://esbench.com/bench/57ee8f8e330ab09900a1a1a0
 *	@see http://jasonformat.com/wtf-is-jsx
 *	@public
 */

function h(nodeName, attributes) {
  var children = EMPTY_CHILDREN,
      lastSimple,
      child,
      simple,
      i;

  for (i = arguments.length; i-- > 2;) {
    stack.push(arguments[i]);
  }

  if (attributes && attributes.children != null) {
    if (!stack.length) stack.push(attributes.children);
    delete attributes.children;
  }

  while (stack.length) {
    if ((child = stack.pop()) && child.pop !== undefined) {
      for (i = child.length; i--;) {
        stack.push(child[i]);
      }
    } else {
      if (typeof child === 'boolean') child = null;

      if (simple = typeof nodeName !== 'function') {
        if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
      }

      if (simple && lastSimple) {
        children[children.length - 1] += child;
      } else if (children === EMPTY_CHILDREN) {
        children = [child];
      } else {
        children.push(child);
      }

      lastSimple = simple;
    }
  }

  var p = new VNode();
  p.nodeName = nodeName;
  p.children = children;
  p.attributes = attributes == null ? undefined : attributes;
  p.key = attributes == null ? undefined : attributes.key; // if a "vnode hook" is defined, pass every created VNode to it

  if (options.vnode !== undefined) options.vnode(p);
  return p;
}
/** Copy own-properties from `props` onto `obj`.
 *	@returns obj
 *	@private
 */


function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }

  return obj;
}
/** Call a function asynchronously, as soon as possible.
 *	@param {Function} callback
 */


var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
} // DOM properties that should NOT have "px" added when numeric


var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
/** Managed queue of dirty components to be re-rendered */

var items = [];

function enqueueRender(component) {
  if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
    (options.debounceRendering || defer)(rerender);
  }
}

function rerender() {
  var p,
      list = items;
  items = [];

  while (p = list.pop()) {
    if (p._dirty) renderComponent(p);
  }
}
/** Check if two nodes are equivalent.
 *	@param {Element} node
 *	@param {VNode} vnode
 *	@private
 */


function isSameNodeType(node, vnode, hydrating) {
  if (typeof vnode === 'string' || typeof vnode === 'number') {
    return node.splitText !== undefined;
  }

  if (typeof vnode.nodeName === 'string') {
    return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
  }

  return hydrating || node._componentConstructor === vnode.nodeName;
}
/** Check if an Element has a given normalized name.
*	@param {Element} node
*	@param {String} nodeName
 */


function isNamedNode(node, nodeName) {
  return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}
/**
 * Reconstruct Component-style `props` from a VNode.
 * Ensures default/fallback values from `defaultProps`:
 * Own-properties of `defaultProps` not present in `vnode.attributes` are added.
 * @param {VNode} vnode
 * @returns {Object} props
 */


function getNodeProps(vnode) {
  var props = extend({}, vnode.attributes);
  props.children = vnode.children;
  var defaultProps = vnode.nodeName.defaultProps;

  if (defaultProps !== undefined) {
    for (var i in defaultProps) {
      if (props[i] === undefined) {
        props[i] = defaultProps[i];
      }
    }
  }

  return props;
}
/** Create an element with the given nodeName.
 *	@param {String} nodeName
 *	@param {Boolean} [isSvg=false]	If `true`, creates an element within the SVG namespace.
 *	@returns {Element} node
 */


function createNode(nodeName, isSvg) {
  var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
  node.normalizedNodeName = nodeName;
  return node;
}
/** Remove a child node from its parent if attached.
 *	@param {Element} node		The node to remove
 */


function removeNode(node) {
  var parentNode = node.parentNode;
  if (parentNode) parentNode.removeChild(node);
}
/** Set a named attribute on the given Node, with special behavior for some names and event handlers.
 *	If `value` is `null`, the attribute/handler will be removed.
 *	@param {Element} node	An element to mutate
 *	@param {string} name	The name/key to set, such as an event or attribute name
 *	@param {any} old	The last value that was set for this name/node pair
 *	@param {any} value	An attribute value, such as a function to be used as an event handler
 *	@param {Boolean} isSvg	Are we currently diffing inside an svg?
 *	@private
 */


function setAccessor(node, name, old, value, isSvg) {
  if (name === 'className') name = 'class';

  if (name === 'key') {// ignore
  } else if (name === 'ref') {
    if (old) old(null);
    if (value) value(node);
  } else if (name === 'class' && !isSvg) {
    node.className = value || '';
  } else if (name === 'style') {
    if (!value || typeof value === 'string' || typeof old === 'string') {
      node.style.cssText = value || '';
    }

    if (value && _typeof(value) === 'object') {
      if (typeof old !== 'string') {
        for (var i in old) {
          if (!(i in value)) node.style[i] = '';
        }
      }

      for (var i in value) {
        node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
      }
    }
  } else if (name === 'dangerouslySetInnerHTML') {
    if (value) node.innerHTML = value.__html || '';
  } else if (name[0] == 'o' && name[1] == 'n') {
    var useCapture = name !== (name = name.replace(/Capture$/, ''));
    name = name.toLowerCase().substring(2);

    if (value) {
      if (!old) node.addEventListener(name, eventProxy, useCapture);
    } else {
      node.removeEventListener(name, eventProxy, useCapture);
    }

    (node._listeners || (node._listeners = {}))[name] = value;
  } else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
    setProperty(node, name, value == null ? '' : value);
    if (value == null || value === false) node.removeAttribute(name);
  } else {
    var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));

    if (value == null || value === false) {
      if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
    } else if (typeof value !== 'function') {
      if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
    }
  }
}
/** Attempt to set a DOM property to the given value.
 *	IE & FF throw for certain property-value combinations.
 */


function setProperty(node, name, value) {
  try {
    node[name] = value;
  } catch (e) {}
}
/** Proxy an event to hooked event handlers
 *	@private
 */


function eventProxy(e) {
  return this._listeners[e.type](options.event && options.event(e) || e);
}
/** Queue of components that have been mounted and are awaiting componentDidMount */


var mounts = [];
/** Diff recursion count, used to track the end of the diff cycle. */

var diffLevel = 0;
/** Global flag indicating if the diff is currently within an SVG */

var isSvgMode = false;
/** Global flag indicating if the diff is performing hydration */

var hydrating = false;
/** Invoke queued componentDidMount lifecycle methods */

function flushMounts() {
  var c;

  while (c = mounts.pop()) {
    if (options.afterMount) options.afterMount(c);
    if (c.componentDidMount) c.componentDidMount();
  }
}
/** Apply differences in a given vnode (and it's deep children) to a real DOM Node.
 *	@param {Element} [dom=null]		A DOM node to mutate into the shape of the `vnode`
 *	@param {VNode} vnode			A VNode (with descendants forming a tree) representing the desired DOM structure
 *	@returns {Element} dom			The created/mutated element
 *	@private
 */


function diff(dom, vnode, context, mountAll, parent, componentRoot) {
  // diffLevel having been 0 here indicates initial entry into the diff (not a subdiff)
  if (!diffLevel++) {
    // when first starting the diff, check if we're diffing an SVG or within an SVG
    isSvgMode = parent != null && parent.ownerSVGElement !== undefined; // hydration is indicated by the existing element to be diffed not having a prop cache

    hydrating = dom != null && !('__preactattr_' in dom);
  }

  var ret = idiff(dom, vnode, context, mountAll, componentRoot); // append the element if its a new parent

  if (parent && ret.parentNode !== parent) parent.appendChild(ret); // diffLevel being reduced to 0 means we're exiting the diff

  if (! --diffLevel) {
    hydrating = false; // invoke queued componentDidMount lifecycle methods

    if (!componentRoot) flushMounts();
  }

  return ret;
}
/** Internals of `diff()`, separated to allow bypassing diffLevel / mount flushing. */


function idiff(dom, vnode, context, mountAll, componentRoot) {
  var out = dom,
      prevSvgMode = isSvgMode; // empty values (null, undefined, booleans) render as empty Text nodes

  if (vnode == null || typeof vnode === 'boolean') vnode = ''; // Fast case: Strings & Numbers create/update Text nodes.

  if (typeof vnode === 'string' || typeof vnode === 'number') {
    // update if it's already a Text node:
    if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
      /* istanbul ignore if */

      /* Browser quirk that can't be covered: https://github.com/developit/preact/commit/fd4f21f5c45dfd75151bd27b4c217d8003aa5eb9 */
      if (dom.nodeValue != vnode) {
        dom.nodeValue = vnode;
      }
    } else {
      // it wasn't a Text node: replace it with one and recycle the old Element
      out = document.createTextNode(vnode);

      if (dom) {
        if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
        recollectNodeTree(dom, true);
      }
    }

    out['__preactattr_'] = true;
    return out;
  } // If the VNode represents a Component, perform a component diff:


  var vnodeName = vnode.nodeName;

  if (typeof vnodeName === 'function') {
    return buildComponentFromVNode(dom, vnode, context, mountAll);
  } // Tracks entering and exiting SVG namespace when descending through the tree.


  isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode; // If there's no existing element or it's the wrong type, create a new one:

  vnodeName = String(vnodeName);

  if (!dom || !isNamedNode(dom, vnodeName)) {
    out = createNode(vnodeName, isSvgMode);

    if (dom) {
      // move children into the replacement node
      while (dom.firstChild) {
        out.appendChild(dom.firstChild);
      } // if the previous Element was mounted into the DOM, replace it inline


      if (dom.parentNode) dom.parentNode.replaceChild(out, dom); // recycle the old element (skips non-Element node types)

      recollectNodeTree(dom, true);
    }
  }

  var fc = out.firstChild,
      props = out['__preactattr_'],
      vchildren = vnode.children;

  if (props == null) {
    props = out['__preactattr_'] = {};

    for (var a = out.attributes, i = a.length; i--;) {
      props[a[i].name] = a[i].value;
    }
  } // Optimization: fast-path for elements containing a single TextNode:


  if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
    if (fc.nodeValue != vchildren[0]) {
      fc.nodeValue = vchildren[0];
    }
  } // otherwise, if there are existing or new children, diff them:
  else if (vchildren && vchildren.length || fc != null) {
      innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
    } // Apply attributes/props from VNode to the DOM Element:


  diffAttributes(out, vnode.attributes, props); // restore previous SVG mode: (in case we're exiting an SVG namespace)

  isSvgMode = prevSvgMode;
  return out;
}
/** Apply child and attribute changes between a VNode and a DOM Node to the DOM.
 *	@param {Element} dom			Element whose children should be compared & mutated
 *	@param {Array} vchildren		Array of VNodes to compare to `dom.childNodes`
 *	@param {Object} context			Implicitly descendant context object (from most recent `getChildContext()`)
 *	@param {Boolean} mountAll
 *	@param {Boolean} isHydrating	If `true`, consumes externally created elements similar to hydration
 */


function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
  var originalChildren = dom.childNodes,
      children = [],
      keyed = {},
      keyedLen = 0,
      min = 0,
      len = originalChildren.length,
      childrenLen = 0,
      vlen = vchildren ? vchildren.length : 0,
      j,
      c,
      f,
      vchild,
      child; // Build up a map of keyed children and an Array of unkeyed children:

  if (len !== 0) {
    for (var i = 0; i < len; i++) {
      var _child = originalChildren[i],
          props = _child['__preactattr_'],
          key = vlen && props ? _child._component ? _child._component.__key : props.key : null;

      if (key != null) {
        keyedLen++;
        keyed[key] = _child;
      } else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
        children[childrenLen++] = _child;
      }
    }
  }

  if (vlen !== 0) {
    for (var i = 0; i < vlen; i++) {
      vchild = vchildren[i];
      child = null; // attempt to find a node based on key matching

      var key = vchild.key;

      if (key != null) {
        if (keyedLen && keyed[key] !== undefined) {
          child = keyed[key];
          keyed[key] = undefined;
          keyedLen--;
        }
      } // attempt to pluck a node of the same type from the existing children
      else if (!child && min < childrenLen) {
          for (j = min; j < childrenLen; j++) {
            if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
              child = c;
              children[j] = undefined;
              if (j === childrenLen - 1) childrenLen--;
              if (j === min) min++;
              break;
            }
          }
        } // morph the matched/found/created DOM child to match vchild (deep)


      child = idiff(child, vchild, context, mountAll);
      f = originalChildren[i];

      if (child && child !== dom && child !== f) {
        if (f == null) {
          dom.appendChild(child);
        } else if (child === f.nextSibling) {
          removeNode(f);
        } else {
          dom.insertBefore(child, f);
        }
      }
    }
  } // remove unused keyed children:


  if (keyedLen) {
    for (var i in keyed) {
      if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
    }
  } // remove orphaned unkeyed children:


  while (min <= childrenLen) {
    if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
  }
}
/** Recursively recycle (or just unmount) a node and its descendants.
 *	@param {Node} node						DOM node to start unmount/removal from
 *	@param {Boolean} [unmountOnly=false]	If `true`, only triggers unmount lifecycle, skips removal
 */


function recollectNodeTree(node, unmountOnly) {
  var component = node._component;

  if (component) {
    // if node is owned by a Component, unmount that component (ends up recursing back here)
    unmountComponent(component);
  } else {
    // If the node's VNode had a ref function, invoke it with null here.
    // (this is part of the React spec, and smart for unsetting references)
    if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

    if (unmountOnly === false || node['__preactattr_'] == null) {
      removeNode(node);
    }

    removeChildren(node);
  }
}
/** Recollect/unmount all children.
 *	- we use .lastChild here because it causes less reflow than .firstChild
 *	- it's also cheaper than accessing the .childNodes Live NodeList
 */


function removeChildren(node) {
  node = node.lastChild;

  while (node) {
    var next = node.previousSibling;
    recollectNodeTree(node, true);
    node = next;
  }
}
/** Apply differences in attributes from a VNode to the given DOM Element.
 *	@param {Element} dom		Element with attributes to diff `attrs` against
 *	@param {Object} attrs		The desired end-state key-value attribute pairs
 *	@param {Object} old			Current/previous attributes (from previous VNode or element's prop cache)
 */


function diffAttributes(dom, attrs, old) {
  var name; // remove attributes no longer present on the vnode by setting them to undefined

  for (name in old) {
    if (!(attrs && attrs[name] != null) && old[name] != null) {
      setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
    }
  } // add new & update changed attributes


  for (name in attrs) {
    if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
      setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
    }
  }
}
/** Retains a pool of Components for re-use, keyed on component name.
 *	Note: since component names are not unique or even necessarily available, these are primarily a form of sharding.
 *	@private
 */


var components = {};
/** Reclaim a component for later re-use by the recycler. */

function collectComponent(component) {
  var name = component.constructor.name;
  (components[name] || (components[name] = [])).push(component);
}
/** Create a component. Normalizes differences between PFC's and classful Components. */


function createComponent(Ctor, props, context) {
  var list = components[Ctor.name],
      inst;

  if (Ctor.prototype && Ctor.prototype.render) {
    inst = new Ctor(props, context);
    Component.call(inst, props, context);
  } else {
    inst = new Component(props, context);
    inst.constructor = Ctor;
    inst.render = doRender;
  }

  if (list) {
    for (var i = list.length; i--;) {
      if (list[i].constructor === Ctor) {
        inst.nextBase = list[i].nextBase;
        list.splice(i, 1);
        break;
      }
    }
  }

  return inst;
}
/** The `.render()` method for a PFC backing instance. */


function doRender(props, state, context) {
  return this.constructor(props, context);
}
/** Set a component's `props` (generally derived from JSX attributes).
 *	@param {Object} props
 *	@param {Object} [opts]
 *	@param {boolean} [opts.renderSync=false]	If `true` and {@link options.syncComponentUpdates} is `true`, triggers synchronous rendering.
 *	@param {boolean} [opts.render=true]			If `false`, no render will be triggered.
 */


function setComponentProps(component, props, opts, context, mountAll) {
  if (component._disable) return;
  component._disable = true;
  if (component.__ref = props.ref) delete props.ref;
  if (component.__key = props.key) delete props.key;

  if (!component.base || mountAll) {
    if (component.componentWillMount) component.componentWillMount();
  } else if (component.componentWillReceiveProps) {
    component.componentWillReceiveProps(props, context);
  }

  if (context && context !== component.context) {
    if (!component.prevContext) component.prevContext = component.context;
    component.context = context;
  }

  if (!component.prevProps) component.prevProps = component.props;
  component.props = props;
  component._disable = false;

  if (opts !== 0) {
    if (opts === 1 || options.syncComponentUpdates !== false || !component.base) {
      renderComponent(component, 1, mountAll);
    } else {
      enqueueRender(component);
    }
  }

  if (component.__ref) component.__ref(component);
}
/** Render a Component, triggering necessary lifecycle events and taking High-Order Components into account.
 *	@param {Component} component
 *	@param {Object} [opts]
 *	@param {boolean} [opts.build=false]		If `true`, component will build and store a DOM node if not already associated with one.
 *	@private
 */


function renderComponent(component, opts, mountAll, isChild) {
  if (component._disable) return;
  var props = component.props,
      state = component.state,
      context = component.context,
      previousProps = component.prevProps || props,
      previousState = component.prevState || state,
      previousContext = component.prevContext || context,
      isUpdate = component.base,
      nextBase = component.nextBase,
      initialBase = isUpdate || nextBase,
      initialChildComponent = component._component,
      skip = false,
      rendered,
      inst,
      cbase; // if updating

  if (isUpdate) {
    component.props = previousProps;
    component.state = previousState;
    component.context = previousContext;

    if (opts !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
      skip = true;
    } else if (component.componentWillUpdate) {
      component.componentWillUpdate(props, state, context);
    }

    component.props = props;
    component.state = state;
    component.context = context;
  }

  component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
  component._dirty = false;

  if (!skip) {
    rendered = component.render(props, state, context); // context to pass to the child, can be updated via (grand-)parent component

    if (component.getChildContext) {
      context = extend(extend({}, context), component.getChildContext());
    }

    var childComponent = rendered && rendered.nodeName,
        toUnmount,
        base;

    if (typeof childComponent === 'function') {
      // set up high order component link
      var childProps = getNodeProps(rendered);
      inst = initialChildComponent;

      if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
        setComponentProps(inst, childProps, 1, context, false);
      } else {
        toUnmount = inst;
        component._component = inst = createComponent(childComponent, childProps, context);
        inst.nextBase = inst.nextBase || nextBase;
        inst._parentComponent = component;
        setComponentProps(inst, childProps, 0, context, false);
        renderComponent(inst, 1, mountAll, true);
      }

      base = inst.base;
    } else {
      cbase = initialBase; // destroy high order component link

      toUnmount = initialChildComponent;

      if (toUnmount) {
        cbase = component._component = null;
      }

      if (initialBase || opts === 1) {
        if (cbase) cbase._component = null;
        base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
      }
    }

    if (initialBase && base !== initialBase && inst !== initialChildComponent) {
      var baseParent = initialBase.parentNode;

      if (baseParent && base !== baseParent) {
        baseParent.replaceChild(base, initialBase);

        if (!toUnmount) {
          initialBase._component = null;
          recollectNodeTree(initialBase, false);
        }
      }
    }

    if (toUnmount) {
      unmountComponent(toUnmount);
    }

    component.base = base;

    if (base && !isChild) {
      var componentRef = component,
          t = component;

      while (t = t._parentComponent) {
        (componentRef = t).base = base;
      }

      base._component = componentRef;
      base._componentConstructor = componentRef.constructor;
    }
  }

  if (!isUpdate || mountAll) {
    mounts.unshift(component);
  } else if (!skip) {
    // Ensure that pending componentDidMount() hooks of child components
    // are called before the componentDidUpdate() hook in the parent.
    // Note: disabled as it causes duplicate hooks, see https://github.com/developit/preact/issues/750
    // flushMounts();
    if (component.componentDidUpdate) {
      component.componentDidUpdate(previousProps, previousState, previousContext);
    }

    if (options.afterUpdate) options.afterUpdate(component);
  }

  if (component._renderCallbacks != null) {
    while (component._renderCallbacks.length) {
      component._renderCallbacks.pop().call(component);
    }
  }

  if (!diffLevel && !isChild) flushMounts();
}
/** Apply the Component referenced by a VNode to the DOM.
 *	@param {Element} dom	The DOM node to mutate
 *	@param {VNode} vnode	A Component-referencing VNode
 *	@returns {Element} dom	The created/mutated element
 *	@private
 */


function buildComponentFromVNode(dom, vnode, context, mountAll) {
  var c = dom && dom._component,
      originalComponent = c,
      oldDom = dom,
      isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
      isOwner = isDirectOwner,
      props = getNodeProps(vnode);

  while (c && !isOwner && (c = c._parentComponent)) {
    isOwner = c.constructor === vnode.nodeName;
  }

  if (c && isOwner && (!mountAll || c._component)) {
    setComponentProps(c, props, 3, context, mountAll);
    dom = c.base;
  } else {
    if (originalComponent && !isDirectOwner) {
      unmountComponent(originalComponent);
      dom = oldDom = null;
    }

    c = createComponent(vnode.nodeName, props, context);

    if (dom && !c.nextBase) {
      c.nextBase = dom; // passing dom/oldDom as nextBase will recycle it if unused, so bypass recycling on L229:

      oldDom = null;
    }

    setComponentProps(c, props, 1, context, mountAll);
    dom = c.base;

    if (oldDom && dom !== oldDom) {
      oldDom._component = null;
      recollectNodeTree(oldDom, false);
    }
  }

  return dom;
}
/** Remove a component from the DOM and recycle it.
 *	@param {Component} component	The Component instance to unmount
 *	@private
 */


function unmountComponent(component) {
  if (options.beforeUnmount) options.beforeUnmount(component);
  var base = component.base;
  component._disable = true;
  if (component.componentWillUnmount) component.componentWillUnmount();
  component.base = null; // recursively tear down & recollect high-order component children:

  var inner = component._component;

  if (inner) {
    unmountComponent(inner);
  } else if (base) {
    if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);
    component.nextBase = base;
    removeNode(base);
    collectComponent(component);
    removeChildren(base);
  }

  if (component.__ref) component.__ref(null);
}
/** Base Component class.
 *	Provides `setState()` and `forceUpdate()`, which trigger rendering.
 *	@public
 *
 *	@example
 *	class MyFoo extends Component {
 *		render(props, state) {
 *			return <div />;
 *		}
 *	}
 */


function Component(props, context) {
  this._dirty = true;
  /** @public
   *	@type {object}
   */

  this.context = context;
  /** @public
   *	@type {object}
   */

  this.props = props;
  /** @public
   *	@type {object}
   */

  this.state = this.state || {};
}

extend(Component.prototype, {
  /** Returns a `boolean` indicating if the component should re-render when receiving the given `props` and `state`.
   *	@param {object} nextProps
   *	@param {object} nextState
   *	@param {object} nextContext
   *	@returns {Boolean} should the component re-render
   *	@name shouldComponentUpdate
   *	@function
   */

  /** Update component state by copying properties from `state` to `this.state`.
   *	@param {object} state		A hash of state properties to update with new values
   *	@param {function} callback	A function to be called once component state is updated
   */
  setState: function setState(state, callback) {
    var s = this.state;
    if (!this.prevState) this.prevState = extend({}, s);
    extend(s, typeof state === 'function' ? state(s, this.props) : state);
    if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
    enqueueRender(this);
  },

  /** Immediately perform a synchronous re-render of the component.
   *	@param {function} callback		A function to be called after component is re-rendered.
   *	@private
   */
  forceUpdate: function forceUpdate(callback) {
    if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
    renderComponent(this, 2);
  },

  /** Accepts `props` and `state`, and returns a new Virtual DOM tree to build.
   *	Virtual DOM is generally constructed via [JSX](http://jasonformat.com/wtf-is-jsx).
   *	@param {object} props		Props (eg: JSX attributes) received from parent element/component
   *	@param {object} state		The component's current state
   *	@param {object} context		Context object (if a parent component has provided context)
   *	@returns VNode
   */
  render: function render() {}
});
/** Render JSX into a `parent` Element.
 *	@param {VNode} vnode		A (JSX) VNode to render
 *	@param {Element} parent		DOM element to render into
 *	@param {Element} [merge]	Attempt to re-use an existing DOM tree rooted at `merge`
 *	@public
 *
 *	@example
 *	// render a div into <body>:
 *	render(<div id="hello">hello!</div>, document.body);
 *
 *	@example
 *	// render a "Thing" component into #foo:
 *	const Thing = ({ name }) => <span>{ name }</span>;
 *	render(<Thing name="one" />, document.querySelector('#foo'));
 */

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
  h: h,
  createElement: h,
  cloneElement: cloneElement,
  Component: Component,
  render: render,
  rerender: rerender,
  options: options
};

/* unused harmony default export */ var _unused_webpack_default_export = (preact);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}



function shallowEqual(a, b) {
  for (var key in a) {
    if (a[key] !== b[key]) return false;
  }

  for (var _key in b) {
    if (!(_key in a)) return false;
  }

  return true;
}

var PureComponent = function (_Component) {
  _inherits(PureComponent, _Component);

  function PureComponent() {
    _classCallCheck(this, PureComponent);

    return _possibleConstructorReturn(this, (PureComponent.__proto__ || Object.getPrototypeOf(PureComponent)).apply(this, arguments));
  }

  _createClass(PureComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(props, state) {
      return !(shallowEqual(props, this.props) && shallowEqual(state, this.state));
    }
  }]);

  return PureComponent;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (PureComponent);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bem__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scroll__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__string__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__bem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__string__["a"]; });
/* unused harmony reexport getScrollLeft */
/* unused harmony reexport getScrollTop */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__array__["a"]; });






/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (global, factory) {
  ( false ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.nrkSerumImagecropUtils = {});
})(this, function (exports) {
  'use strict';

  var isPolopolyIdRegex = /^[1-9]{1,2}\.\d+$/;

  function isPolopolyId(id) {
    if (!id) {
      return false;
    }

    return isPolopolyIdRegex.test(id);
  } // prettier-ignore


  var widths = [100, 120, 150, 174, 200, 206, 225, 244, 250, 252, 300, 320, 350, 400, 450, 452, 460, 462, 500, 600, 650, 665, 682, 700, 734, 768, 900, 974, 1200, 1280, 1360, 1450, 1550, 1600, 1700, 1800, 1920, 2000, 2100, 2200, 2300, 2400]; // prettier-ignore

  var ratios = ['1:1', '11', '16:9', '169', '16:3', '163', '3:4', '34']; // prettier-ignore

  var qualities = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0];
  var _baseUrl = 'https://nrk.no/serum/api/imagecrop/';

  function createUrl(_ref) {
    var id = _ref.id,
        ratio = _ref.ratio,
        width = _ref.width,
        quality = _ref.quality;
    var url = '' + _baseUrl + id;
    var queryString = createQueryString({
      ratio: ratio,
      width: width,
      quality: quality
    });

    if (queryString) {
      url += '?' + queryString;
    }

    return url;
  }

  function createQueryString(_ref2) {
    var ratio = _ref2.ratio,
        width = _ref2.width,
        quality = _ref2.quality;

    if (!ratio && !width) {
      return quality ? 'quality=' + quality : '';
    }

    var ratioPart = ratio ? 'f' + ratio.replace(':', '') : '';
    var widthPart = width ? 'w' + width : '';
    var qualityPart = quality ? '&quality=' + quality : '';
    return 'cropid=' + ratioPart + widthPart + qualityPart;
  }

  function getClosestNumber(goal, targets) {
    if (!isValidGoal(goal)) {
      throw new Error('\n      getClosestNumber(goal, targets): passing a goal of ' + goal + '\n      is not supported. Pass a number');
    }

    if (!isValidTargets(targets)) {
      throw new Error('\n      getClosestNumber(goal, targets): targets ' + targets.toString() + ' is invald.\n      Pass an array of numbers');
    }

    if (!targets.length) {
      // eslint-disable-next-line no-undefined
      return undefined;
    }

    return targets.reduce(function (prev, curr) {
      return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
    });
  }

  function isValidGoal(goal) {
    return typeof goal === 'number';
  }

  function isValidTargets(targets) {
    if (!targets) {
      return false;
    }

    var isValid = true;

    for (var i = 0; i < targets.length; i++) {
      if (typeof targets[i] !== 'number') {
        isValid = false;
        break;
      }
    } // return targets.some((target) => {
    //   return (typeof target !== 'number')
    // })


    return isValid;
  }

  function isValidRatio(ratio, supportedRatios) {
    if (!Array.isArray(supportedRatios)) {
      // eslint-disable-next-line no-useless-escape
      throw new Error("isValidRatio(ratio, supportedRatios): supportedRatios '" + supportedRatios + "' is not supported. Pass an array of supported ratios");
    }

    if (!ratio) {
      return false;
    }

    return supportedRatios.includes(ratio);
  }

  function isValidQuality(quality, supportedQualities) {
    if (!Array.isArray(supportedQualities)) {
      // eslint-disable-next-line no-useless-escape
      throw new Error("isValidQuality(quality, supportedQualities): supportedQualities '" + supportedQualities + "' is not supported. Pass an array of supported qualities");
    }

    if (!quality) {
      return false;
    }

    return supportedQualities.includes(quality);
  }

  function createImageUrl(options) {
    var polopolyId = options.id,
        width = options.width,
        ratio = options.ratio,
        quality = options.quality;

    if (!isPolopolyId(polopolyId)) {
      throw new Error('createSerumImageUrl(): invalid polopolyId. Got ' + polopolyId);
    }

    var args = {
      id: polopolyId,
      ratio: null,
      quality: 0.8,
      width: 0 // If a ratio is provided, ensure that it is valid

    };

    if (hasOption(ratio)) {
      if (!isValidRatio(ratio, ratios)) {
        throw new Error('\n      createSerumImageUrl(): ratio ' + ratio + ' is not supported.\n      Supported ratios are ' + ratios.toString());
      }

      args.ratio = ratio;
    } // If a quality is provided, ensure that it is valid


    if (hasOption(quality)) {
      if (!isValidQuality(quality, qualities)) {
        throw new Error('\n      createSerumImageUrl(): quality ' + quality + ' is not supported.\n      Supported qualities are ' + qualities.toString());
      }

      args.quality = quality;
    } // If a width is provided, ensure that is is a positive integer


    if (hasOption(width)) {
      if (!isNumber(width) || width <= 0) {
        var errorMessage = 'createSerumImageUrl(): width must be a positive integer, got ' + width;
        throw new Error(errorMessage);
      }

      var isSupportedWidth = widths.includes(width);
      var closestWidth = getClosestNumber(width, widths);

      if (typeof closestWidth !== 'undefined' && closestWidth) {
        args.width = isSupportedWidth ? width : closestWidth;
      }
    }

    return createUrl(args);
  }

  function hasOption(option) {
    return typeof option !== 'undefined' && option;
  }

  function isNumber(number) {
    return Number.isInteger(number);
  }

  exports.createImageUrl = createImageUrl;
  exports.ratios = ratios;
  exports.widths = widths;
  exports.qualities = qualities;
  exports.isPolopolyId = isPolopolyId;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Avatar; });
/* unused harmony export getInitials */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AvatarImage__ = __webpack_require__(39);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h





var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};
var Avatar = function (_Component) {
  _inherits(Avatar, _Component);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
  }

  _createClass(Avatar, [{
    key: 'render',
    value: function render() {
      var person = this.props.person;
      var name = person.name,
          image = person.image;
      var displayImage = image && image.type !== 'none';
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        'aria-hidden': true,
        className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.avatar, person.side)
      }, displayImage && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__AvatarImage__["a" /* AvatarImage */], {
        image: image,
        alt: person.name,
        title: person.name
      }), !displayImage && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
        className: styles.avatar__placeholder,
        title: name
      }, getInitials(name)));
    }
  }]);

  return Avatar;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);
function getInitials() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var initials = name.replace(/\(.*\)/, '').trim().split(/[ -]/).map(function (item) {
    return item.charAt(0).toUpperCase();
  });
  if (initials.length < 2) return initials[0];
  return [initials[0], initials[initials.length - 1]].join('');
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getImageUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__);

function getImageUrl(image, options) {
  var _ref = options || {},
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 120 : _ref$width,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === undefined ? '1:1' : _ref$ratio;

  switch (image.type) {
    case 'polopoly-image':
      {
        return Object(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__["createImageUrl"])({
          id: image.id,
          width: width,
          ratio: ratio
        });
      }

    case 'url-image':
      {
        return image.url;
      }
  }
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h

/* eslint-disable jsx-a11y/media-has-caption */





var Video = function (_PureComponent) {
  _inherits(Video, _PureComponent);

  function Video() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Video);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Video.__proto__ || Object.getPrototypeOf(Video)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isPlaying: false,
      isResolvingPlay: false,
      time: 0
    }, _this.tracks = [], _this.handlePlay = function () {
      var onPlay = _this.props.onPlay;

      _this.setState({
        isPlaying: true
      });

      if (onPlay) {
        onPlay();
      }
    }, _this.handlePause = function () {
      var onPause = _this.props.onPause;

      _this.setState({
        isPlaying: false
      });

      if (onPause) {
        onPause();
      }
    }, _this.handleDurationChange = function () {
      var onDurationChange = _this.props.onDurationChange;

      if (onDurationChange) {
        onDurationChange(_this.elm.duration);
      }
    }, _this.handleTimeupdate = function () {
      var onTimeupdate = _this.props.onTimeupdate;
      var time = _this.elm.currentTime;

      _this.setState({
        time: time
      });

      if (onTimeupdate) {
        onTimeupdate(time);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          textTracks = _props.textTracks,
          playing = _props.playing,
          onCaptionCueEnter = _props.onCaptionCueEnter,
          onCaptionCueExit = _props.onCaptionCueExit;

      if (textTracks) {
        textTracks.forEach(function (textTrack) {
          var track = _this2.elm.addTextTrack('subtitles', textTrack.language);

          track.mode = 'hidden';

          _this2.tracks.push(track);

          try {
            textTrack.captions.forEach(function (a) {
              return track.addCue(new window.VTTCue(Number(a.in), Number(a.out), a.text));
            });
          } catch (_) {
            // ignore error
            textTrack.captions.forEach(function (a) {
              return track.addCue(new window.TextTrackCue(Number(a.in), Number(a.out), a.text));
            });
          }

          var _loop = function _loop(i) {
            var cue = track.cues[i];

            try {
              cue.onenter = function () {
                if (typeof onCaptionCueEnter !== 'undefined') {
                  onCaptionCueEnter({
                    in: cue.startTime,
                    out: cue.endTime,
                    text: cue.text
                  });
                }
              };

              cue.onexit = function () {
                if (typeof onCaptionCueExit !== 'undefined') {
                  onCaptionCueExit();
                }
              };
            } catch (_) {// ignore error
            }
          };

          for (var i = 0; i < track.cues.length; i++) {
            _loop(i);
          }
        });
      }

      if (playing) {
        this.play();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.playing !== this.props.playing) {
        if (this.props.playing) {
          this.play();
        } else {
          this.pause();
        }
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var _this3 = this;

      var onError = this.props.onError;
      var playPromise = this.elm.play();

      if (playPromise) {
        this.setState({
          isResolvingPlay: true
        });
        playPromise.then(function () {
          _this3.setState({
            isResolvingPlay: false
          });
        }).catch(function (err) {
          if (onError) {
            onError(err.message);
          }

          _this3.setState({
            isResolvingPlay: false
          });
        });
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.elm.pause();
    }
  }, {
    key: 'seek',
    value: function seek(time) {
      this.elm.currentTime = time;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          playing = _props2.playing,
          sources = _props2.sources,
          restProps = _objectWithoutProperties(_props2, ['playing', 'sources']);

      var isPlaying = this.state.isPlaying;
      var eventHandlers = {
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onDurationChange: this.handleDurationChange,
        onTimeupdate: this.handleTimeupdate
      };
      var dataProps = {};

      if (isPlaying) {
        dataProps['data-playing'] = true;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('video', _extends({}, restProps, eventHandlers, {
        ref: function ref(elm) {
          return _this4.elm = elm;
        }
      }, dataProps), sources.map(function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('source', _extends({}, source, {
          key: source.type
        }));
      }));
    }
  }]);

  return Video;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IMAGE_WIDTHS */
/* harmony export (immutable) */ __webpack_exports__["a"] = createResponsiveSrcSet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__);

var IMAGE_WIDTHS = [320, 450, 650, 768, 900, 1280, 1600, 1920, 2400];
function createResponsiveSrcSet(opts) {
  var id = opts.id,
      ratio = opts.ratio,
      quality = opts.quality;
  return IMAGE_WIDTHS.map(function (width) {
    var imageUrl = Object(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__["createImageUrl"])({
      id: id,
      width: width,
      ratio: ratio,
      quality: quality
    });
    return imageUrl + ' ' + width + 'w';
  }).join(', ');
}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"dh-stille-spesial-root","app":"dh-stille-spesial-app"};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Byline__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChatLog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailList__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Figure__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Heading__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_Icon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List_ListItem__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Paragraph__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PullQuote__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_preact_pure_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__video_ResponsiveVideo__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__serum_SerumImage__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__serum_SerumResponsivePicture__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__serum_SerumSmartPicture__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__serum_lazy_SerumLazyResponsivePicture__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Slideshow_Slide__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Slideshow__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__video_SmartVideo__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__video_Video__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__video_VideoPlayer__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ViewportIntersections__ = __webpack_require__(65);
/* unused harmony reexport Byline */
/* unused harmony reexport ChatLog */
/* unused harmony reexport EmailList */
/* unused harmony reexport Figure */
/* unused harmony reexport Heading */
/* unused harmony reexport Icon */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__List__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__List_ListItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__Paragraph__["a"]; });
/* unused harmony reexport PullQuote */
/* unused harmony reexport PureComponent */
/* unused harmony reexport ResponsiveVideo */
/* unused harmony reexport SerumImage */
/* unused harmony reexport SerumSmartPicture */
/* unused harmony reexport SerumResponsivePicture */
/* unused harmony reexport SerumLazyResponsivePicture */
/* unused harmony reexport Slide */
/* unused harmony reexport Slideshow */
/* unused harmony reexport SmartVideo */
/* unused harmony reexport Video */
/* unused harmony reexport VideoPlayer */
/* unused harmony reexport ViewportIntersections */
























/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body__wrapper":"dh-stille-spesial-body__wrapper","body__paragraph-wrapper":"dh-stille-spesial-body__paragraph-wrapper","body__header-wrapper":"dh-stille-spesial-body__header-wrapper","body__h2":"dh-stille-spesial-body__h2","body__h3":"dh-stille-spesial-body__h3","body__paragraph":"dh-stille-spesial-body__paragraph","body__paragraph--centered":"dh-stille-spesial-body__paragraph--centered","body__paragraph--spaced":"dh-stille-spesial-body__paragraph--spaced","body__image":"dh-stille-spesial-body__image","fact__box":"dh-stille-spesial-fact__box"};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


var h = __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */];

var Provider =
/*#__PURE__*/
function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, _getPrototypeOf(Provider).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this$props = this.props,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["children"]);

      return {
        __CTX__: props
      };
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children[0];
    }
  }]);

  return Provider;
}(Component);

Provider.displayName = 'Provider';

function connect(mapContextToProps) {
  return function (wrappedComponent) {
    var Connected =
    /*#__PURE__*/
    function (_Component2) {
      _inherits(Connected, _Component2);

      function Connected() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, Connected);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Connected)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mapContextToProps", function (ctx) {
          return mapContextToProps ? mapContextToProps(ctx) : ctx;
        });

        return _this;
      }

      _createClass(Connected, [{
        key: "render",
        value: function render() {
          return h(wrappedComponent, _objectSpread({}, this.mapContextToProps(this.context['__CTX__']), this.props));
        }
      }]);

      return Connected;
    }(Component);

    Connected.displayName = "connect(".concat(wrappedComponent.displayName || wrappedComponent.name || 'Component', ")");
    return Connected;
  };
}



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EsiInclude; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var h = __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */];
var ESI_PREFIX = 'https://nrk.no';
var IS_CLIENT = typeof window !== 'undefined';
var EsiInclude =
/*#__PURE__*/
function (_Component) {
  _inherits(EsiInclude, _Component);

  function EsiInclude() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, EsiInclude);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EsiInclude)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      fetchedHtml: null
    });

    return _this;
  }

  _createClass(EsiInclude, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.fetchedHtml !== nextState.fetchedHtml;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          get = _this$props.get,
          path = _this$props.path;

      if (get) {
        get(path).then(function (fetchedHtml) {
          return _this2.setState({
            fetchedHtml: fetchedHtml
          });
        }).catch(console.error);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          path = _this$props2.path,
          get = _this$props2.get;
      var esiUrl = "".concat(ESI_PREFIX).concat(path);

      if (!get) {
        if (IS_CLIENT) {
          var html = document.querySelector("[data-esi-url=\"".concat(path, "\"]"));

          if (html) {
            return h("div", {
              dangerouslySetInnerHTML: {
                __html: html.innerHTML
              }
            });
          }

          return null;
        }

        return h("div", {
          "data-esi-url": path,
          dangerouslySetInnerHTML: {
            __html: "<esi:include src=\"".concat(path, "\" />")
          }
        });
      } else {
        var _fetchedHtml = this.state.fetchedHtml;

        if (!_fetchedHtml) {
          return h("div", null);
        } else {
          return h("div", {
            "data-esi-url": esiUrl,
            dangerouslySetInnerHTML: {
              __html: _fetchedHtml
            }
          });
        }
      }
    }
  }]);

  return EsiInclude;
}(Component);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"parallax-container":"dh-stille-spesial-parallax-container","layer":"dh-stille-spesial-layer","bg":"dh-stille-spesial-bg dh-stille-spesial-layer","wall":"dh-stille-spesial-wall dh-stille-spesial-layer","wall--animate":"dh-stille-spesial-wall--animate","parallax__wrapper":"dh-stille-spesial-parallax__wrapper"};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(15);
module.exports = __webpack_require__(18);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intersection_observer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_intersection_observer__);
/* eslint-disable */


__webpack_require__(17).polyfill();

if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array

    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function (window, document) {
  'use strict'; // Exits early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.

  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }

    return;
  }
  /**
   * An IntersectionObserver registry. This registry exists to hold a strong
   * reference to IntersectionObserver instances currently observing a target
   * element. Without this registry, instances without another reference may be
   * garbage collected.
   */


  var registry = [];
  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */

  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = entry.rootBounds;
    this.boundingClientRect = entry.boundingClientRect;
    this.intersectionRect = entry.intersectionRect || getEmptyRect();
    this.isIntersecting = !!entry.intersectionRect; // Calculates the intersection ratio.

    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height; // Sets intersection ratio.

    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }
  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */


  function IntersectionObserver(callback, opt_options) {
    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1) {
      throw new Error('root must be an Element');
    } // Binds and throttles `this._checkForIntersections`.


    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT); // Private properties.

    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin); // Public properties.

    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');
  }
  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */


  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */

  IntersectionObserver.prototype.POLL_INTERVAL = null;
  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */

  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */

  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });

    if (isTargetAlreadyObserved) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();

    this._observationTargets.push({
      element: target,
      entry: null
    });

    this._monitorIntersections();

    this._checkForIntersections();
  };
  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */


  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {
      return item.element != target;
    });

    if (!this._observationTargets.length) {
      this._unmonitorIntersections();

      this._unregisterInstance();
    }
  };
  /**
   * Stops observing all target elements for intersection changes.
   */


  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];

    this._unmonitorIntersections();

    this._unregisterInstance();
  };
  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */


  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();

    this._queuedEntries = [];
    return records;
  };
  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */


  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];
    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }

      return t !== a[i - 1];
    });
  };
  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */


  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);

      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }

      return {
        value: parseFloat(parts[1]),
        unit: parts[2]
      };
    }); // Handles shorthand.

    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];
    return margins;
  };
  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibility state is visible.
   * @private
   */


  IntersectionObserver.prototype._monitorIntersections = function () {
    if (!this._monitoringIntersections) {
      this._monitoringIntersections = true; // If a poll interval is set, use polling instead of listening to
      // resize and scroll events or DOM mutations.

      if (this.POLL_INTERVAL) {
        this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL);
      } else {
        addEvent(window, 'resize', this._checkForIntersections, true);
        addEvent(document, 'scroll', this._checkForIntersections, true);

        if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
          this._domObserver = new MutationObserver(this._checkForIntersections);

          this._domObserver.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    }
  };
  /**
   * Stops polling for intersection changes.
   * @private
   */


  IntersectionObserver.prototype._unmonitorIntersections = function () {
    if (this._monitoringIntersections) {
      this._monitoringIntersections = false;
      clearInterval(this._monitoringInterval);
      this._monitoringInterval = null;
      removeEvent(window, 'resize', this._checkForIntersections, true);
      removeEvent(document, 'scroll', this._checkForIntersections, true);

      if (this._domObserver) {
        this._domObserver.disconnect();

        this._domObserver = null;
      }
    }
  };
  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */


  IntersectionObserver.prototype._checkForIntersections = function () {
    var rootIsInDom = this._rootIsInDom();

    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);

      var rootContainsTarget = this._rootContainsTarget(target);

      var oldEntry = item.entry;

      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, rootRect);

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootRect,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };
  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */


  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, rootRect) {
    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;
    var targetRect = getBoundingClientRect(target);
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {}; // If the parent isn't displayed, an intersection can't happen.

      if (parentComputedStyle.display == 'none') return;

      if (parent == this.root || parent == document) {
        atRoot = true;
        parentRect = rootRect;
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        if (parent != document.body && parent != document.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      } // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.


      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
        if (!intersectionRect) break;
      }

      parent = getParentNode(parent);
    }

    return intersectionRect;
  };
  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {Object} The expanded root rect.
   * @private
   */


  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;

    if (this.root) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var html = document.documentElement;
      var body = document.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }

    return this._expandRectByRootMargin(rootRect);
  };
  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {Object} rect The rect object to expand.
   * @return {Object} The expanded rect.
   * @private
   */


  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });

    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;
    return newRect;
  };
  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */


  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {
    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1; // Ignore unchanged ratios

    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i]; // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.

      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };
  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */


  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };
  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */


  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    return containsDeep(this.root || document, target);
  };
  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */


  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };
  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */


  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };
  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */


  function now() {
    return window.performance && performance.now && performance.now();
  }
  /**
   * Throttles a function and delays its execution, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */


  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }
  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */


  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }
  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */


  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }
  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object} The intersection rect or undefined if no intersection
   *     is found.
   */


  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;
    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    };
  }
  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {Object} The (possibly shimmed) rect of the element.
   */


  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {// Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect(); // Older IE

    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }

    return rect;
  }
  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {Object} The empty rect.
   */


  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  /**
   * Checks to see if a parent element contains a child element (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */


  function containsDeep(parent, child) {
    var node = child;

    while (node) {
      if (node == parent) return true;
      node = getParentNode(node);
    }

    return false;
  }
  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */


  function getParentNode(node) {
    var parent = node.parentNode;

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }

    return parent;
  } // Exposes the constructors globally.


  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})(window, document);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */


function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);

  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];

    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));

    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }

  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domready__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domready___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_domready__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_errorReporting__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_App_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nrk_dh_analytics_utils__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nrk_dh_analytics_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__nrk_dh_analytics_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_getContextId__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_provider_ts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_preact__ = __webpack_require__(0);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* global __HOT__ */
// @jsx h









var h = __WEBPACK_IMPORTED_MODULE_8_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_8_preact__["a" /* Component */],
    render = __WEBPACK_IMPORTED_MODULE_8_preact__["c" /* render */];
window[__WEBPACK_IMPORTED_MODULE_4__components_App_css__["root"]] = window[__WEBPACK_IMPORTED_MODULE_4__components_App_css__["root"]] || {};

function init() {
  findElements(__WEBPACK_IMPORTED_MODULE_4__components_App_css__["root"]).forEach(function (el) {
    el.id = Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["b" /* createUniqueId */])();
    window[__WEBPACK_IMPORTED_MODULE_4__components_App_css__["root"]][el.id] = true; // Extract values sent from server

    var name = el.getAttribute('data-name');
    var preloadedState = JSON.parse(decodeURIComponent(el.getAttribute('data-preloaded-state')));
    var errorTrackingEnabled = el.getAttribute('data-error-tracking-enabled') === 'true';
    var sendError;
    var sendGaEvent;

    try {
      // setup error reporting
      var simpleErrorReport = Object(__WEBPACK_IMPORTED_MODULE_2__lib_errorReporting__["a" /* createErrorReporter */])(name, errorTrackingEnabled);
      simpleErrorReport.listenAndCatch(); // Extract metadata required to create google analytics tracker

      var gaPropertyId = el.getAttribute('data-ga-property-id');
      var metadata = JSON.parse(el.getAttribute('data-metadata'));
      var title = metadata.title,
          selfId = metadata.selfId,
          published = metadata.published; // create google analytics tracker

      var googleAnalyticsTracker = Object(__WEBPACK_IMPORTED_MODULE_5__nrk_dh_analytics_utils__["createGoogleAnalyticsTracker"])({
        name: 'dh',
        gaPropertyId: gaPropertyId,
        self: {
          id: selfId,
          title: title,
          publishedDate: published ? new Date(published) : null
        },
        context: {
          id: Object(__WEBPACK_IMPORTED_MODULE_6__lib_getContextId__["a" /* getContextId */])(document.location.href)
        }
      });

      sendError = function sendError(message) {
        simpleErrorReport.sendErrorReport({
          message: message
        });
      };

      sendGaEvent = function sendGaEvent(eventObj) {
        googleAnalyticsTracker.sendEvent(_objectSpread({
          category: "dh-modul-".concat(name)
        }, eventObj));
      };
    } catch (error) {
      console.error({
        error: error
      });
    } // ... and render with the exact same props as on server


    render(h(__WEBPACK_IMPORTED_MODULE_7__lib_provider_ts__["a" /* Provider */], {
      sendGaEvent: sendGaEvent,
      sendError: sendError
    }, h(__WEBPACK_IMPORTED_MODULE_3__components_App__["a" /* App */], preloadedState)), el, el.firstChild); // Enable webpack hot-reloading

    if (false) {
      // Reload and re-render preact application
      module.hot.accept('./client', function () {
        var _require = require('./components/App'),
            App = _require.App;

        var _require2 = require('../lib/provider'),
            CustomProvider = _require2.Provider;

        render(h(CustomProvider, {
          sendGaEvent: sendGaEvent,
          sendError: sendError
        }, h(App, preloadedState)), el, el.firstChild);
      });
    }
  });
}

if (false) {
  require('preact/devtools');
}

function findElements(className) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["c" /* toArray */])(document.getElementsByClassName(className)).filter(function (el) {
    return !isInitialized(el, className);
  });
}

function isInitialized(el, className) {
  return el.id && window[className][el.id];
}

__WEBPACK_IMPORTED_MODULE_0_domready___default()(init);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {
  if (true) module.exports = definition();else if (typeof define == 'function' && _typeof(define.amd) == 'object') define(definition);else this[name] = definition();
}('domready', function () {
  var fns = [],
      _listener,
      doc = document,
      hack = doc.documentElement.doScroll,
      domContentLoaded = 'DOMContentLoaded',
      loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);

  if (!loaded) doc.addEventListener(domContentLoaded, _listener = function listener() {
    doc.removeEventListener(domContentLoaded, _listener);
    loaded = 1;

    while (_listener = fns.shift()) {
      _listener();
    }
  });
  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  };
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
function toArray(nodeList) {
  return [].slice.call(nodeList);
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function toStrings(object) {
  return Object.keys(object).filter(function (key) {
    return object[key];
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function (blockName) {
  for (var _len = arguments.length, modifiers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    modifiers[_key - 1] = arguments[_key];
  }

  var strings = modifiers.filter(function (modifier) {
    return typeof modifier === 'string';
  });
  var objects = modifiers.filter(function (modifier) {
    return _typeof(modifier) === 'object';
  });
  var objectString = objects.map(function (object) {
    return toStrings(object);
  }).reduce(function (a, b) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(b));
  }, []);
  return [blockName].concat(strings.map(function (modifier) {
    return blockName + '--' + modifier;
  })).concat(objectString.map(function (modifier) {
    return blockName + '--' + modifier;
  })).join(' ');
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getScrollLeft */
/* unused harmony export getScrollTop */
function getScrollLeft() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.pageXOffset || document.documentElement && document.documentElement.scrollLeft || 0;
}
function getScrollTop() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.pageYOffset || document.documentElement && document.documentElement.scrollTop || 0;
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createUniqueId;
function createUniqueId() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return '' + prefix + Math.random().toString(36).substr(2, len - prefix.length);
}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createErrorReporter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_dh_simple_error_report__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_dh_simple_error_report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nrk_dh_simple_error_report__);

function createErrorReporter(name, isErrorReportingEnabled) {
  return new __WEBPACK_IMPORTED_MODULE_0__nrk_dh_simple_error_report__["SimpleErrorReport"]({
    name: name,
    url: 'https://dh.nrk.no/catch',
    dryRun: !isErrorReportingEnabled
  });
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : n(e["simple-error-report"] = {});
}(this, function (e) {
  "use strict";

  var n = function () {
    function e(e, n) {
      for (var r = 0; r < n.length; r++) {
        var t = n[r];
        t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }

    return function (n, r, t) {
      return r && e(n.prototype, r), t && e(n, t), n;
    };
  }();

  var r = function () {
    function e() {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.register = [];
    }

    return n(e, [{
      key: "addErrorToRegister",
      value: function value(e) {
        this.register.push({
          time: new Date(),
          message: e
        });
      }
    }, {
      key: "isInRegisterWithinRange",
      value: function value(e, n) {
        return this.register.filter(function (r) {
          return r.message === e && new Date() - r.time < n;
        }).length > 0;
      }
    }]), e;
  }(),
      t = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
      }
    }

    return e;
  },
      i = function () {
    function e(e, n) {
      for (var r = 0; r < n.length; r++) {
        var t = n[r];
        t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }

    return function (n, r, t) {
      return r && e(n.prototype, r), t && e(n, t), n;
    };
  }();

  var o = [],
      s = function () {
    function e(n) {
      var t = n.name,
          i = n.url,
          s = n.dryRun,
          a = void 0 === s || s,
          u = n.parseStack;
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.name = t, this.url = i, this.errorRegister = new r(), this.dryRun = a, u && (this.parseStack = u), o.push(this.name);
    }

    return i(e, [{
      key: "listenAndCatch",
      value: function value() {
        var e = this;
        o.length <= 1 && (window.addEventListener("error", function (n) {
          var r = n.message,
              i = n.filename,
              o = n.lineno,
              s = n.colno,
              a = {
            message: r
          };
          "" !== i && (a.url = i), o > 0 && (a.line = o), s > 0 && (a.column = s), n.error && "function" == typeof e.parseStack ? e.parseStack(n.error).then(function (n) {
            e.sendErrorReport(t({}, a, {
              stackTrace: n
            }));
          }) : e.sendErrorReport(a);
        }), window.addEventListener("unhandledrejection", function (n) {
          e.sendErrorReport({
            message: "Unhandled Promise Rejection: " + n.reason
          });
        }));
      }
    }, {
      key: "sendErrorReport",
      value: function value(e) {
        var n, r, t;
        this.dryRun ? "undefined" != typeof console && console.log("Dry run: " + JSON.stringify(e)) : this.errorRegister.isInRegisterWithinRange(e.message, 500) || (this.errorRegister.addErrorToRegister(e.message), n = this.url + "/" + this.name, r = e, (t = new XMLHttpRequest()).open("POST", n), t.setRequestHeader("Content-Type", "application/json"), t.send(JSON.stringify(r)));
      }
    }]), e;
  }();

  e.SimpleErrorReport = s, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header___ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Body___ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_provider__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Body_Part__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Body_Kloster__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_preact__ = __webpack_require__(0);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var h = __WEBPACK_IMPORTED_MODULE_7_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_7_preact__["a" /* Component */];

var _App =
/*#__PURE__*/
function (_Component) {
  _inherits(_App, _Component);

  function _App() {
    var _this;

    _classCallCheck(this, _App);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(_App).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "intersectionObserver", undefined);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "kloster", undefined);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "header", undefined);

    _this.state = {
      klosterActive: false,
      headerActive: false
    };
    return _this;
  }

  _createClass(_App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.intersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (entry.target === _this2.kloster.wrapper) {
              _this2.setState({
                klosterActive: true
              });
            } else if (entry.target === _this2.header.el) {
              _this2.setState({
                headerActive: true
              });
            }
          } else {
            if (entry.target === _this2.kloster.wrapper) {
              _this2.setState({
                klosterActive: false
              });
            } else if (entry.target === _this2.header.el) {
              _this2.setState({
                headerActive: false
              });
            }
          }
        });
      });
      this.intersectionObserver.observe(this.kloster.wrapper);
      this.intersectionObserver.observe(this.header.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.intersectionObserver.unobserve(this.kloster.wrapper);
      this.intersectionObserver.unobserve(this.header.el); // Disconnect intersection observer

      this.intersectionObserver.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return h("div", {
        class: __WEBPACK_IMPORTED_MODULE_0__App_css___default.a.app
      }, h("script", {
        src: "https://static.nrk.no/core-masthead/major/1/core-masthead.html.js"
      }), h(__WEBPACK_IMPORTED_MODULE_1__Header___["a" /* Header */], {
        ingress: this.props.doc.ingress,
        ref: function ref(el) {
          return _this3.header = el;
        },
        visible: this.state.headerActive
      }), h(__WEBPACK_IMPORTED_MODULE_2__Body___["a" /* Body */], null, h(__WEBPACK_IMPORTED_MODULE_5__Body_Part__["a" /* Part */], {
        part: this.props.doc['part-1']
      }), h(__WEBPACK_IMPORTED_MODULE_6__Body_Kloster__["a" /* Kloster */], {
        visible: this.state.klosterActive,
        ref: function ref(el) {
          return _this3.kloster = el;
        }
      }), h(__WEBPACK_IMPORTED_MODULE_5__Body_Part__["a" /* Part */], {
        part: this.props.doc['part-2']
      }), h(__WEBPACK_IMPORTED_MODULE_5__Body_Part__["a" /* Part */], {
        part: this.props.doc['part-3']
      })), h(__WEBPACK_IMPORTED_MODULE_4__Footer__["a" /* Footer */], null));
    }
  }]);

  return _App;
}(Component);

var App = Object(__WEBPACK_IMPORTED_MODULE_3__lib_provider__["b" /* connect */])()(_App);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Title__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Background__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Man__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Ingress__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MaxViewportRect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact__ = __webpack_require__(0);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var h = __WEBPACK_IMPORTED_MODULE_6_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_6_preact__["a" /* Component */];
var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Header)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "el", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      opacity: 1,
      height: -1,
      percentFinished: 0
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "wrapper", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "update", function () {
      if (_this.props.visible) {
        requestAnimationFrame(_this.update);

        if (_this.wrapper) {
          var _this$wrapper$getBoun = _this.wrapper.getBoundingClientRect(),
              top = _this$wrapper$getBoun.top,
              _height = _this$wrapper$getBoun.height;

          var _percentFinished = -top / _height;

          _this.setState({
            percentFinished: _percentFinished
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onViewportChange", function (height) {
      if (height !== _this.state.height) {
        _this.setState({
          height: height
        });
      }
    });

    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.visible) {
        requestAnimationFrame(this.update);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.visible !== this.props.visible) {
        this.update();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var ingress = this.props.ingress;

      var inlineStyle = _defineProperty({}, 'margin-top', -this.state.height);

      return h("div", {
        class: __WEBPACK_IMPORTED_MODULE_5__index_css__["header"],
        ref: function ref(el) {
          _this2.wrapper = el;
        }
      }, h(__WEBPACK_IMPORTED_MODULE_4__MaxViewportRect__["a" /* MaxViewportRect */], {
        onViewportChange: this.onViewportChange
      }), h(__WEBPACK_IMPORTED_MODULE_1__Background__["a" /* Background */], {
        height: this.state.height,
        percentFinished: this.state.percentFinished
      }), h("div", {
        class: __WEBPACK_IMPORTED_MODULE_5__index_css__["header__content"],
        ref: function ref(el) {
          _this2.el = el;
        },
        style: inlineStyle
      }, h(__WEBPACK_IMPORTED_MODULE_3__Ingress__["a" /* Ingress */], {
        ingress: ingress
      }), h("div", {
        className: __WEBPACK_IMPORTED_MODULE_5__index_css__["titleWrapper"]
      }, h(__WEBPACK_IMPORTED_MODULE_2__Man__["a" /* Man */], {
        percentFinished: this.state.percentFinished
      }), h(__WEBPACK_IMPORTED_MODULE_0__Title__["a" /* Title */], {
        percentFinished: this.state.percentFinished
      }))));
    }
  }]);

  return Header;
}(Component);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Title; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);


var h = __WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */];
var Title = function Title(_ref) {
  var percentFinished = _ref.percentFinished;
  return h("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_0__index_css___default.a['textWrapper'], " ").concat(percentFinished > 0.6 ? __WEBPACK_IMPORTED_MODULE_0__index_css___default.a['textWrapper--animate'] : null)
  }, h("div", {
    className: __WEBPACK_IMPORTED_MODULE_0__index_css___default.a.textInnerWrapper
  }, h("h1", {
    className: __WEBPACK_IMPORTED_MODULE_0__index_css___default.a.title
  }, "Stille i stormen"), h("div", {
    className: __WEBPACK_IMPORTED_MODULE_0__index_css___default.a.byline
  }, "Av Christian Nicolai Bj\xF8rke")));
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"textWrapper":"dh-stille-spesial-textWrapper","textInnerWrapper":"dh-stille-spesial-textInnerWrapper","title":"dh-stille-spesial-title","textWrapper--animate":"dh-stille-spesial-textWrapper--animate","byline":"dh-stille-spesial-byline"};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Background; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var h = __WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */];
var Background =
/*#__PURE__*/
function (_Component) {
  _inherits(Background, _Component);

  function Background() {
    var _this;

    _classCallCheck(this, Background);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Background).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dispose", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "elm", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "viewport$", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOpacity", function () {
      var stopPosition = 0.44;
      var opacity = (stopPosition - _this.props.percentFinished) / stopPosition;

      if (opacity <= 0.05) {
        return 0.05;
      }

      return opacity;
    });

    return _this;
  }

  _createClass(Background, [{
    key: "render",
    value: function render() {
      var inlineStyle = {
        height: "".concat(this.props.height, "px"),
        opacity: this.getOpacity()
      };
      return h("div", {
        class: __WEBPACK_IMPORTED_MODULE_0__index_css__["header__img"],
        style: inlineStyle
      }, h("picture", null, h("source", {
        media: "(orientation: portrait)",
        srcset: "https://static.nrk.no/dh/module/stille-spesial/assets/Header/portrait/bg-768.jpg 768w, https://static.nrk.no/dh/module/stille-spesial/assets/Header/portrait/bg-375.jpg 375w"
      }), h("source", {
        media: "(orientation: landscape)",
        srcset: "https://static.nrk.no/dh/module/stille-spesial/assets/Header/landscape/bg-1920.jpg 1920w, https://static.nrk.no/dh/module/stille-spesial/assets/Header/landscape/bg-1280.jpg 1280w, https://static.nrk.no/dh/module/stille-spesial/assets/Header/landscape/bg-1024.jpg 1024w, https://static.nrk.no/dh/module/stille-spesial/assets/Header/landscape/bg-900.jpg 900w,"
      }), h("img", {
        alt: "",
        className: __WEBPACK_IMPORTED_MODULE_0__index_css__["header__bg-img"],
        src: "https://static.nrk.no/dh/module/stille-spesial/assets/Header/landscape/bg-1024.jpg"
      })));
    }
  }]);

  return Background;
}(Component);

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header__img":"dh-stille-spesial-header__img","header__bg-img":"dh-stille-spesial-header__bg-img"};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Man; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }



var h = __WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */];
var Man =
/*#__PURE__*/
function (_Component) {
  _inherits(Man, _Component);

  function Man() {
    _classCallCheck(this, Man);

    return _possibleConstructorReturn(this, _getPrototypeOf(Man).apply(this, arguments));
  }

  _createClass(Man, [{
    key: "render",
    value: function render() {
      return h("picture", {
        className: __WEBPACK_IMPORTED_MODULE_0__index_css__["imgWrapper"]
      }, h("source", {
        srcset: "https://static.nrk.no/dh/module/stille-spesial/assets/Header/mann/mann-400.webp",
        type: "image/webp"
      }), h("img", {
        className: __WEBPACK_IMPORTED_MODULE_0__index_css__["header__fg-img"],
        src: "https://static.nrk.no/dh/module/stille-spesial/assets/Header/mann/mann-300.png",
        alt: ""
      }));
    }
  }]);

  return Man;
}(Component);

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header__fg-img":"dh-stille-spesial-header__fg-img","imgWrapper":"dh-stille-spesial-imgWrapper"};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ingress; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_dh_feature_components__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact__ = __webpack_require__(0);



var h = __WEBPACK_IMPORTED_MODULE_2_preact__["b" /* h */];
var Ingress = function Ingress(_ref) {
  var ingress = _ref.ingress;
  var mappedIngress = ingress && ingress.map(function (item) {
    switch (item.type) {
      case 'title':
        return null;

      case 'text':
        return h(__WEBPACK_IMPORTED_MODULE_0__nrk_dh_feature_components__["c" /* Paragraph */], {
          key: item.value.split('.')[0],
          html: item.value.replace('\n', '<br>').trim(),
          className: __WEBPACK_IMPORTED_MODULE_1__index_css__["ingress__paragraph"]
        });

      default:
        return JSON.stringify(item.value, null, 2);
    }
  });
  return h("div", {
    className: __WEBPACK_IMPORTED_MODULE_1__index_css__["ingress__wrapper"]
  }, mappedIngress);
};

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h




var style = {
  'byline': 'dhfc-1_0_0-beta_26-byline',
  'byline__name': 'dhfc-1_0_0-beta_26-byline__name'
};

var Byline = function (_PureComponent) {
  _inherits(Byline, _PureComponent);

  function Byline() {
    _classCallCheck(this, Byline);

    return _possibleConstructorReturn(this, (Byline.__proto__ || Object.getPrototypeOf(Byline)).apply(this, arguments));
  }

  _createClass(Byline, [{
    key: 'render',
    value: function render() {
      var authors = this.props.authors;
      var len = authors.length;
      var className = '' + style.byline + (this.props.className ? ' ' + this.props.className : '');
      if (len === 0) return null;
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: className
      }, 'Av', ' ', authors.map(function (author, idx) {
        if (len === 1) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
            key: String(idx)
          }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
            className: style.byline__name,
            dangerouslySetInnerHTML: {
              __html: author.name
            }
          }));
        }

        if (idx === len - 1) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
            key: String(idx)
          }, '&', ' ', Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
            className: style.byline__name,
            dangerouslySetInnerHTML: {
              __html: author.name
            }
          }));
        }

        if (idx === len - 2) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
            key: String(idx)
          }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
            className: style.byline__name,
            dangerouslySetInnerHTML: {
              __html: author.name
            }
          }), ' ');
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
          key: String(idx)
        }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
          className: style.byline__name,
          dangerouslySetInnerHTML: {
            __html: author.name
          }
        }), ',', ' ');
      }));
    }
  }]);

  return Byline;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Byline);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Message__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Date__ = __webpack_require__(42);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h






var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};

var ChatLog = function (_PureComponent) {
  _inherits(ChatLog, _PureComponent);

  function ChatLog() {
    _classCallCheck(this, ChatLog);

    return _possibleConstructorReturn(this, (ChatLog.__proto__ || Object.getPrototypeOf(ChatLog)).apply(this, arguments));
  }

  _createClass(ChatLog, [{
    key: 'render',
    value: function render() {
      var messages = this.props.messages;
      var className = '' + styles.chatLog + (this.props.className ? ' ' + this.props.className : '');
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: className
      }, messages.map(function (message, idx) {
        return [Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__Date__["a" /* Date */], {
          date: message.date,
          index: idx,
          key: 'date_' + idx
        }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__Message__["a" /* Message */], {
          key: idx,
          isLastInGroup: isLastInGroup(messages, idx),
          message: message
        })];
      }));
    }
  }]);

  return ChatLog;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

function isLastInGroup(messages, index) {
  return messages.length - 1 === index;
}

/* unused harmony default export */ var _unused_webpack_default_export = (ChatLog);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Message; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImageMessage__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextMessage__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ImagesMessage_index__ = __webpack_require__(41);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h






var Message = function (_Component) {
  _inherits(Message, _Component);

  function Message() {
    _classCallCheck(this, Message);

    return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
  }

  _createClass(Message, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLastInGroup = _props.isLastInGroup,
          message = _props.message;
      var content = message.content;
      var type = content.type;

      switch (type) {
        case 'image':
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__ImageMessage__["a" /* ImageMessage */], {
            message: message,
            isLastInGroup: isLastInGroup
          });

        case 'images':
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__ImagesMessage_index__["a" /* ImagesMessage */], {
            message: message,
            isLastInGroup: isLastInGroup
          });

        case 'text':
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__TextMessage__["a" /* TextMessage */], {
            message: message,
            isLastInGroup: isLastInGroup
          });

        default:
          throw new Error('Unknown message type ' + type);
      }
    }
  }]);

  return Message;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Avatar_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_image_url__ = __webpack_require__(5);
//  @jsx h




var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};
var ImageMessage = function ImageMessage(props) {
  var message = props.message,
      isLastInGroup = props.isLastInGroup;
  var from = message.from,
      content = message.content;
  var name = from.name,
      side = from.side,
      display = from.display;
  var showAvatar = ['avatar', 'both'].indexOf(display) !== -1;
  var showName = ['name', 'both'].indexOf(display) !== -1;
  var imageSrc = Object(__WEBPACK_IMPORTED_MODULE_3__lib_image_url__["a" /* getImageUrl */])(content.image, {
    width: 320,
    ratio: '1:1'
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message, side, {
      showAvatar: showAvatar,
      isLastInGroup: isLastInGroup
    })
  }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
    className: 'nrk-sr'
  }, name, ':'), showAvatar && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__Avatar_index__["a" /* Avatar */], {
    person: from
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message__content, side, {
      showName: showName
    })
  }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
    'aria-hidden': true,
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message__name, side)
  }, showName && name), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message__image, side)
  }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('img', {
    src: imageSrc,
    alt: content.image.alt || '',
    nopin: 'nopin',
    'data-pin-nopin': 'true'
  }))));
};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AvatarImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_image_url__ = __webpack_require__(5);
//  @jsx h


var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};
function AvatarImage(props) {
  var image = props.image,
      alt = props.alt,
      title = props.title;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('img', {
    className: styles.avatarImage,
    title: title,
    src: Object(__WEBPACK_IMPORTED_MODULE_1__lib_image_url__["a" /* getImageUrl */])(image),
    alt: alt,
    nopin: 'no-pin',
    'data-pin-nopin': 'true'
  });
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Avatar__ = __webpack_require__(4);
//  @jsx h



var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};
var TextMessage = function TextMessage(props) {
  var message = props.message,
      isLastInGroup = props.isLastInGroup;
  var from = message.from,
      content = message.content;
  var name = from.name,
      side = from.side,
      display = from.display;
  var showAvatar = ['avatar', 'both'].indexOf(display) !== -1;
  var showName = ['name', 'both'].indexOf(display) !== -1;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message, side, {
      showAvatar: showAvatar,
      isLastInGroup: isLastInGroup
    })
  }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
    className: 'nrk-sr'
  }, name, ':'), showAvatar && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__Avatar__["a" /* Avatar */], {
    person: from
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message__content, side, {
      showName: showName
    })
  }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
    'aria-hidden': true,
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message__name, side)
  }, showName && name), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message__text, side),
    dangerouslySetInnerHTML: {
      __html: content.message
    }
  })));
};

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImagesMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Avatar_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_image_url__ = __webpack_require__(5);
//  @jsx h




var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};
var ImagesMessage = function ImagesMessage(props) {
  var message = props.message,
      isLastInGroup = props.isLastInGroup;
  var from = message.from,
      content = message.content;
  var name = from.name,
      side = from.side,
      display = from.display;
  var showAvatar = ['avatar', 'both'].indexOf(display) !== -1;
  var showName = ['name', 'both'].indexOf(display) !== -1;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message, side, {
      showAvatar: showAvatar,
      isLastInGroup: isLastInGroup
    })
  }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
    className: 'nrk-sr'
  }, name, ':'), showAvatar && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__Avatar_index__["a" /* Avatar */], {
    person: from
  }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message__content, side, {
      showName: showName
    })
  }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
    'aria-hidden': true,
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message__name, side)
  }, showName && name), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('ul', {
    className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.message__images, side)
  }, content.images.map(function (image, idx) {
    var imageSrc = Object(__WEBPACK_IMPORTED_MODULE_3__lib_image_url__["a" /* getImageUrl */])(image, {
      width: 160,
      ratio: '1:1'
    });
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('li', {
      key: idx
    }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('img', {
      src: imageSrc,
      alt: image.alt || '',
      nopin: 'nopin',
      'data-pin-nopin': 'true'
    }));
  }))));
};

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Date; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h




var styles = {
  'chatLog': 'dhfc-1_0_0-beta_26-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_26-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_26-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_26-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_26-avatar--right',
  'date': 'dhfc-1_0_0-beta_26-date',
  'date--isFirst': 'dhfc-1_0_0-beta_26-date--isFirst',
  'message': 'dhfc-1_0_0-beta_26-message',
  'message--left': 'dhfc-1_0_0-beta_26-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_26-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_26-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_26-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_26-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_26-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_26-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_26-message__image',
  'message__images': 'dhfc-1_0_0-beta_26-message__images',
  'message__image--expanded': 'dhfc-1_0_0-beta_26-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_26-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_26-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_26-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_26-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_26-message__name',
  'message__content': 'dhfc-1_0_0-beta_26-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_26-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_26-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_26-message__content--showName'
};
var Date = function (_Component) {
  _inherits(Date, _Component);

  function Date() {
    _classCallCheck(this, Date);

    return _possibleConstructorReturn(this, (Date.__proto__ || Object.getPrototypeOf(Date)).apply(this, arguments));
  }

  _createClass(Date, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          date = _props.date,
          index = _props.index;
      if (!date) return null;
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('h4', {
        className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.date, {
          isFirst: index === 0
        }),
        dangerouslySetInnerHTML: {
          __html: date
        }
      });
    }
  }]);

  return Date;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HtmlContent_index__ = __webpack_require__(44);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** @jsx h */




var styles = {
  'emailList': 'dhfc-1_0_0-beta_26-emailList',
  'email': 'dhfc-1_0_0-beta_26-email',
  'email--left': 'dhfc-1_0_0-beta_26-email--left',
  'email--right': 'dhfc-1_0_0-beta_26-email--right',
  'email__header': 'dhfc-1_0_0-beta_26-email__header'
};

var nbsp = String.fromCharCode(160);

var EmailList = function (_Component) {
  _inherits(EmailList, _Component);

  function EmailList() {
    _classCallCheck(this, EmailList);

    return _possibleConstructorReturn(this, (EmailList.__proto__ || Object.getPrototypeOf(EmailList)).apply(this, arguments));
  }

  _createClass(EmailList, [{
    key: 'render',
    value: function render() {
      var emails = this.props.emails;
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: styles.emailList
      }, emails.map(function (email, idx) {
        var datetime = email.datetime,
            from = email.from,
            to = email.to,
            subject = email.subject,
            message = email.message,
            align = email.align;
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
          className: Object(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_utils__["a" /* bem */])(styles.email, align),
          key: idx
        }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
          className: styles.email__header
        }, from && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', null, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('strong', null, 'Fra:'), ' ', from), to && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', null, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('strong', null, 'Til:'), ' ', to), datetime && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
          className: styles.email_header_datetime
        }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('strong', null, 'Sendt:'), ' ', datetime), subject && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', null, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('strong', null, 'Emne:'), ' ', subject)), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__HtmlContent_index__["a" /* HtmlContent */], {
          content: message && message.replace(nbsp, ' ')
        }));
      }));
    }
  }]);

  return EmailList;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/* unused harmony default export */ var _unused_webpack_default_export = (EmailList);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HtmlContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** @jsx h */



var HtmlContent = function (_Component) {
  _inherits(HtmlContent, _Component);

  function HtmlContent() {
    _classCallCheck(this, HtmlContent);

    return _possibleConstructorReturn(this, (HtmlContent.__proto__ || Object.getPrototypeOf(HtmlContent)).apply(this, arguments));
  }

  _createClass(HtmlContent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.content !== this.props.content;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          className = _props.className,
          dataKey = _props.dataKey;

      switch (this.props.type) {
        case 'p':
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('p', {
            className: className,
            dangerouslySetInnerHTML: {
              __html: content
            },
            'data-key': dataKey
          });

        case 'div':
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
            className: className,
            dangerouslySetInnerHTML: {
              __html: content
            },
            'data-key': dataKey
          });

        default:
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
            className: className,
            dangerouslySetInnerHTML: {
              __html: content
            },
            'data-key': dataKey
          });
      }
    }
  }]);

  return HtmlContent;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h




var style = {
  'figure': 'dhfc-1_0_0-beta_26-figure',
  'figure__credit': 'dhfc-1_0_0-beta_26-figure__credit'
};

var Figure = function (_PureComponent) {
  _inherits(Figure, _PureComponent);

  function Figure() {
    _classCallCheck(this, Figure);

    return _possibleConstructorReturn(this, (Figure.__proto__ || Object.getPrototypeOf(Figure)).apply(this, arguments));
  }

  _createClass(Figure, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          caption = _props.caption,
          credit = _props.credit,
          media = _props.media;
      var className = '' + style.figure + (this.props.className ? ' ' + this.props.className : '');
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('figure', {
        className: className
      }, media, caption && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('figcaption', null, caption.map(function (text, idx) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('p', {
          dangerouslySetInnerHTML: {
            __html: text
          },
          key: String(idx)
        });
      }), credit && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: style.figure__credit
      }, credit)));
    }
  }]);

  return Figure;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Figure);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h

/* eslint-disable jsx-a11y/heading-has-content */




var style = {
  'heading': 'dhfc-1_0_0-beta_26-heading'
};

var Heading = function (_PureComponent) {
  _inherits(Heading, _PureComponent);

  function Heading() {
    _classCallCheck(this, Heading);

    return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
  }

  _createClass(Heading, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          html = _props.html,
          level = _props.level;
      var className = '' + style.heading + (this.props.className ? ' ' + this.props.className : '');
      var htmlProps = {
        className: className
      };

      if (html) {
        htmlProps.dangerouslySetInnerHTML = {
          __html: html
        };
      } else {
        htmlProps.children = children;
      }

      switch (level) {
        case 2:
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('h2', htmlProps);

        case 3:
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('h3', htmlProps);

        case 4:
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('h4', htmlProps);

        case 5:
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('h5', htmlProps);

        case 6:
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('h6', htmlProps);

        default:
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('h1', htmlProps);
      }
    }
  }]);

  return Heading;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Heading);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
//  @jsx h

var style = {
  'icon': 'dhfc-1_0_0-beta_26-icon'
};

function Icon(props) {
  var className = '' + style.icon + (props.className ? ' ' + props.className : '');
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('svg', {
    className: className,
    'aria-hidden': props['aria-hidden'],
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-' + props.symbol + '" />'
    }
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Icon);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h




var style = {
  'list': 'dhfc-1_0_0-beta_26-list'
};

var List = function (_PureComponent) {
  _inherits(List, _PureComponent);

  function List() {
    _classCallCheck(this, List);

    return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
  }

  _createClass(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          type = _props.type;
      var className = '' + style.list + (this.props.className ? ' ' + this.props.className : '');

      if (type === 'numbered') {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('ol', {
          className: className
        }, children);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('ul', {
        className: className
      }, children);
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h





var ListItem = function (_PureComponent) {
  _inherits(ListItem, _PureComponent);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          html = _props.html;

      if (html) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('li', {
          dangerouslySetInnerHTML: {
            __html: html
          }
        });
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('li', null, children);
    }
  }]);

  return ListItem;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ListItem);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h




var style = {
  'paragraph': 'dhfc-1_0_0-beta_26-paragraph'
};

var Paragraph = function (_PureComponent) {
  _inherits(Paragraph, _PureComponent);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).apply(this, arguments));
  }

  _createClass(Paragraph, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          html = _props.html;
      var className = '' + style.paragraph + (this.props.className ? ' ' + this.props.className : '');

      if (html) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('p', {
          className: className,
          dangerouslySetInnerHTML: {
            __html: html
          }
        });
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('p', {
        className: className
      }, children);
    }
  }]);

  return Paragraph;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Paragraph);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h

/* eslint-disable jsx-a11y/aria-role */




var style = {
  'pullQuote': 'dhfc-1_0_0-beta_26-pullQuote',
  'pullQuote__content': 'dhfc-1_0_0-beta_26-pullQuote__content',
  'pullQuote__footer': 'dhfc-1_0_0-beta_26-pullQuote__footer'
};

var PullQuote = function (_PureComponent) {
  _inherits(PullQuote, _PureComponent);

  function PullQuote() {
    _classCallCheck(this, PullQuote);

    return _possibleConstructorReturn(this, (PullQuote.__proto__ || Object.getPrototypeOf(PullQuote)).apply(this, arguments));
  }

  _createClass(PullQuote, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cite = _props.cite,
          html = _props.html;
      var className = '' + style.pullQuote + (this.props.className ? ' ' + this.props.className : '');
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('blockquote', {
        className: className
      }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: style.pullQuote__content
      }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('p', {
        dangerouslySetInnerHTML: {
          __html: html
        }
      })), cite && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('footer', {
        className: style.pullQuote__footer
      }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('cite', {
        role: 'text'
      }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('svg', {
        viewBox: '0 0 20 30',
        'aria-hidden': 'true'
      }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('path', {
        d: 'M 5.5,5.5 L5.5,24.5 L14.5,24.5'
      }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('circle', {
        cx: '5.5',
        cy: '5.5',
        r: '3.5'
      })), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
        dangerouslySetInnerHTML: {
          __html: "<span class=\"nrk-sr\">\u2013 </span>" + (cite || '')
        }
      }))));
    }
  }]);

  return PullQuote;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (PullQuote);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Video__ = __webpack_require__(6);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h






var style = {
  'responsiveVideo': 'dhfc-1_0_0-beta_26-responsiveVideo',
  'responsiveVideo__720p': 'dhfc-1_0_0-beta_26-responsiveVideo__720p',
  'responsiveVideo--1080p': 'dhfc-1_0_0-beta_26-responsiveVideo--1080p',
  'responsiveVideo__1080p': 'dhfc-1_0_0-beta_26-responsiveVideo__1080p'
};
var THRESHOLD_1080P = 960;

var ResponsiveVideo = function (_PureComponent) {
  _inherits(ResponsiveVideo, _PureComponent);

  function ResponsiveVideo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ResponsiveVideo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResponsiveVideo.__proto__ || Object.getPrototypeOf(ResponsiveVideo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      time: 0
    }, _this.handleTimeupdate = function (time) {
      var onTimeupdate = _this.props.onTimeupdate;

      _this.setState({
        time: time
      });

      if (onTimeupdate) {
        onTimeupdate(time);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ResponsiveVideo, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevIs1080p = prevProps.viewport.width >= THRESHOLD_1080P;
      var is1080p = this.props.viewport.width >= THRESHOLD_1080P;

      if (is1080p !== prevIs1080p) {
        this.seek(this.state.time);
      }
    }
  }, {
    key: 'seek',
    value: function seek(time) {
      var is1080p = this.props.viewport.width >= THRESHOLD_1080P;

      if (is1080p) {
        this.resolution1080p.seek(time);
      } else {
        this.resolution720p.seek(time);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          resolution720p = _props.resolution720p,
          resolution1080p = _props.resolution1080p,
          viewport = _props.viewport,
          restProps = _objectWithoutProperties(_props, ['playing', 'resolution720p', 'resolution1080p', 'viewport']);

      if (!resolution720p) {
        throw new Error('Missing `resolution720p` property');
      }

      if (!resolution1080p) {
        throw new Error('Missing `resolution1080p` property');
      }

      var isValidViewport = viewport.width > -1 && viewport.height > -1;
      var is1080p = viewport.width >= THRESHOLD_1080P;
      var className = '' + Object(__WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__["a" /* bem */])(style.responsiveVideo, is1080p && '1080p') + (this.props.className ? ' ' + this.props.className : '');
      return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('div', {
        className: className
      }, Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__Video__["a" /* default */], _extends({}, resolution720p, restProps, {
        className: style.responsiveVideo__720p,
        playing: isValidViewport && !is1080p && playing,
        onTimeupdate: this.handleTimeupdate,
        ref: function ref(resolution720p) {
          return _this2.resolution720p = resolution720p;
        }
      })), Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__Video__["a" /* default */], _extends({}, resolution1080p, restProps, {
        className: style.responsiveVideo__1080p,
        playing: isValidViewport && is1080p && playing,
        onTimeupdate: this.handleTimeupdate,
        ref: function ref(resolution1080p) {
          return _this2.resolution1080p = resolution1080p;
        }
      })));
    }
  }]);

  return ResponsiveVideo;
}(__WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (ResponsiveVideo);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** @jsx h */






var SerumImage = function (_PureComponent) {
  _inherits(SerumImage, _PureComponent);

  function SerumImage() {
    _classCallCheck(this, SerumImage);

    return _possibleConstructorReturn(this, (SerumImage.__proto__ || Object.getPrototypeOf(SerumImage)).apply(this, arguments));
  }

  _createClass(SerumImage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          alt = _props.alt,
          id = _props.id,
          quality = _props.quality,
          ratio = _props.ratio,
          width = _props.width;
      var src = Object(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__["createImageUrl"])({
        id: id,
        width: width,
        quality: quality,
        ratio: ratio
      });
      return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('img', {
        className: className,
        src: src,
        alt: alt
      });
    }
  }]);

  return SerumImage;
}(__WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (SerumImage);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(7);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** @jsx h */







var SerumResponsivePicture = function (_PureComponent) {
  _inherits(SerumResponsivePicture, _PureComponent);

  function SerumResponsivePicture() {
    _classCallCheck(this, SerumResponsivePicture);

    return _possibleConstructorReturn(this, (SerumResponsivePicture.__proto__ || Object.getPrototypeOf(SerumResponsivePicture)).apply(this, arguments));
  }

  _createClass(SerumResponsivePicture, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          alt = _props.alt,
          id = _props.id,
          quality = _props.quality,
          ratio = _props.ratio;
      var defaultUrl = Object(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__["createImageUrl"])({
        id: id,
        width: 1600,
        quality: quality,
        ratio: ratio || '16:9'
      });
      var horizontalSourceSet = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* createResponsiveSrcSet */])({
        id: id,
        quality: quality,
        ratio: ratio || '16:9'
      });
      return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('picture', {
        className: className
      }, Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('source', {
        srcSet: horizontalSourceSet
      }), Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('img', {
        src: defaultUrl,
        alt: alt
      }));
    }
  }]);

  return SerumResponsivePicture;
}(__WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (SerumResponsivePicture);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(7);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** @jsx h */







var SerumSmartPicture = function (_PureComponent) {
  _inherits(SerumSmartPicture, _PureComponent);

  function SerumSmartPicture() {
    _classCallCheck(this, SerumSmartPicture);

    return _possibleConstructorReturn(this, (SerumSmartPicture.__proto__ || Object.getPrototypeOf(SerumSmartPicture)).apply(this, arguments));
  }

  _createClass(SerumSmartPicture, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          alt = _props.alt,
          horizontal = _props.horizontal,
          vertical = _props.vertical;
      var defaultUrl = Object(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__["createImageUrl"])(_extends({}, horizontal, {
        width: 1600,
        ratio: '16:9'
      }));
      var horizontalSourceSet = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* createResponsiveSrcSet */])(_extends({}, horizontal, {
        ratio: '16:9'
      }));
      var verticalSourceSet = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* createResponsiveSrcSet */])(_extends({}, vertical, {
        ratio: '3:4'
      }));
      return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('picture', {
        className: className
      }, Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('source', {
        media: '(min-aspect-ratio: 4/5)',
        srcSet: horizontalSourceSet
      }), Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('source', {
        media: '(max-aspect-ratio: 4/5)',
        srcSet: verticalSourceSet
      }), Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('img', {
        src: defaultUrl,
        alt: alt
      }));
    }
  }]);

  return SerumSmartPicture;
}(__WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (SerumSmartPicture);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(7);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** @jsx h */






var SerumLazyResponsivePicture = function (_Component) {
  _inherits(SerumLazyResponsivePicture, _Component);

  function SerumLazyResponsivePicture() {
    _classCallCheck(this, SerumLazyResponsivePicture);

    return _possibleConstructorReturn(this, (SerumLazyResponsivePicture.__proto__ || Object.getPrototypeOf(SerumLazyResponsivePicture)).apply(this, arguments));
  }

  _createClass(SerumLazyResponsivePicture, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.load && !this.props.load) {
        this.loadImage();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'loadImage',
    value: function loadImage() {
      var _this2 = this;

      var loaderImage = new Image();

      if (this.visibleImage.dataset) {
        loaderImage.srcset = this.visibleImage.dataset.srcset || '';
        loaderImage.sizes = this.visibleImage.sizes || '';
      }

      loaderImage.src = this.visibleImage.dataset.src;

      if (typeof loaderImage.decode === 'function') {
        // Use Image Decode API to decode image upfront if available
        // (Unsure if this works when transferring src to other image, but worth the try)
        loaderImage.decode().then(function () {
          return _this2.updateImage(loaderImage);
        });
      } else if (loaderImage.complete) {
        this.updateImage(loaderImage);
      } else {
        loaderImage.onload = function () {
          return _this2.updateImage(loaderImage);
        };
      }
    }
  }, {
    key: 'updateImage',
    value: function updateImage(loaderImage) {
      var _this3 = this;

      requestAnimationFrame(function () {
        _this3.visibleImage.src = loaderImage.currentSrc || loaderImage.src;
        _this3.visibleImage.style.filter = 'blur(0)';
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          className = _props.className,
          alt = _props.alt,
          id = _props.id,
          _props$quality = _props.quality,
          quality = _props$quality === undefined ? 0.6 : _props$quality,
          _props$ratio = _props.ratio,
          ratio = _props$ratio === undefined ? '16:9' : _props$ratio,
          sizes = _props.sizes;
      var placeholderSrc = Object(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__["createImageUrl"])({
        id: id,
        width: 100,
        quality: 0.6,
        ratio: ratio
      });
      var defaultUrl = Object(__WEBPACK_IMPORTED_MODULE_0__nrk_serum_imagecrop_utils__["createImageUrl"])({
        id: id,
        width: 1600,
        quality: quality,
        ratio: ratio
      });
      var sourceSet = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* createResponsiveSrcSet */])({
        id: id,
        quality: quality,
        ratio: ratio
      });
      return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('picture', {
        className: className,
        style: {
          display: 'block',
          overflow: 'hidden'
        }
      }, Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('img', {
        src: placeholderSrc,
        alt: alt,
        'data-src': defaultUrl,
        'data-srcset': sourceSet,
        style: {
          width: '100%',
          filter: 'blur(10px)',
          transition: 'filter 500ms'
        },
        sizes: sizes,
        ref: function ref(elm) {
          return _this4.visibleImage = elm;
        }
      }));
    }
  }]);

  return SerumLazyResponsivePicture;
}(__WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */]);

/* unused harmony default export */ var _unused_webpack_default_export = (SerumLazyResponsivePicture);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h





var style = {
  'slideshow': 'dhfc-1_0_0-beta_26-slideshow',
  'slideshow__slide': 'dhfc-1_0_0-beta_26-slideshow__slide',
  'slideshow__slide--stacked': 'dhfc-1_0_0-beta_26-slideshow__slide--stacked',
  'slideshow__slide--visible': 'dhfc-1_0_0-beta_26-slideshow__slide--visible',
  'slideshow__slide--active': 'dhfc-1_0_0-beta_26-slideshow__slide--active'
};

var Slide = function (_PureComponent) {
  _inherits(Slide, _PureComponent);

  function Slide() {
    _classCallCheck(this, Slide);

    return _possibleConstructorReturn(this, (Slide.__proto__ || Object.getPrototypeOf(Slide)).apply(this, arguments));
  }

  _createClass(Slide, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          stacked = _props.stacked,
          visible = _props.visible;
      var className = '' + Object(__WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__["a" /* bem */])(style.slideshow__slide, stacked && 'stacked', visible && 'visible', active && 'active') + (this.props.className ? ' ' + this.props.className : '');
      return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('div', {
        className: className
      }, children);
    }
  }]);

  return Slide;
}(__WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Slide);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h




var style = {
  'slideshow': 'dhfc-1_0_0-beta_26-slideshow',
  'slideshow__slide': 'dhfc-1_0_0-beta_26-slideshow__slide',
  'slideshow__slide--stacked': 'dhfc-1_0_0-beta_26-slideshow__slide--stacked',
  'slideshow__slide--visible': 'dhfc-1_0_0-beta_26-slideshow__slide--visible',
  'slideshow__slide--active': 'dhfc-1_0_0-beta_26-slideshow__slide--active'
};

var Slideshow = function (_PureComponent) {
  _inherits(Slideshow, _PureComponent);

  function Slideshow() {
    _classCallCheck(this, Slideshow);

    return _possibleConstructorReturn(this, (Slideshow.__proto__ || Object.getPrototypeOf(Slideshow)).apply(this, arguments));
  }

  _createClass(Slideshow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          viewport = _props.viewport;
      var activeIndex = this.props.activeIndex || 0;
      var className = '' + style.slideshow + (this.props.className ? ' ' + this.props.className : '');
      var inlineStyle = {};

      if (viewport && viewport.height > -1) {
        inlineStyle.height = viewport.height + 'px';
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: className,
        style: inlineStyle,
        'data-active-index': String(activeIndex)
      }, children.map(function (child, idx) {
        if (idx <= activeIndex) {
          child.attributes.stacked = true;
        }

        if (idx >= activeIndex - 1 && idx <= activeIndex + 1) {
          child.attributes.visible = true;
        }

        child.attributes.active = idx === activeIndex;
        return child;
      }));
    }
  }]);

  return Slideshow;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Slideshow);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Video__ = __webpack_require__(6);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h






var style = {
  'smartVideo': 'dhfc-1_0_0-beta_26-smartVideo',
  'smartVideo__720p': 'dhfc-1_0_0-beta_26-smartVideo__720p',
  'smartVideo--horizontal': 'dhfc-1_0_0-beta_26-smartVideo--horizontal',
  'smartVideo--1080p': 'dhfc-1_0_0-beta_26-smartVideo--1080p',
  'smartVideo__960p': 'dhfc-1_0_0-beta_26-smartVideo__960p',
  'smartVideo__1080p': 'dhfc-1_0_0-beta_26-smartVideo__1080p'
};
var THRESHOLD_1080P = 960;
var THRESHOLD_HORIZONTAL = 2 / 3;

var SmartVideo = function (_PureComponent) {
  _inherits(SmartVideo, _PureComponent);

  function SmartVideo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SmartVideo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmartVideo.__proto__ || Object.getPrototypeOf(SmartVideo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      time: 0
    }, _this.handleTimeupdate = function (time) {
      var onTimeupdate = _this.props.onTimeupdate;

      _this.setState({
        time: time
      });

      if (onTimeupdate) {
        onTimeupdate(time);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SmartVideo, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevIsHorizontal = prevProps.viewport.width / prevProps.viewport.height >= THRESHOLD_HORIZONTAL;
      var isHorizontal = this.props.viewport.width / this.props.viewport.height >= THRESHOLD_HORIZONTAL;
      var prevIs1080p = prevProps.viewport.width >= THRESHOLD_1080P;
      var is1080p = this.props.viewport.width >= THRESHOLD_1080P;

      if (prevIsHorizontal !== isHorizontal || is1080p !== prevIs1080p) {
        this.seek(this.state.time);
      }
    }
  }, {
    key: 'seek',
    value: function seek(time) {
      var viewport = this.props.viewport;
      var isHorizontal = viewport.width / viewport.height >= THRESHOLD_HORIZONTAL;
      var is1080p = viewport.width >= THRESHOLD_1080P;

      if (isHorizontal) {
        if (is1080p) {
          this.resolution1080p.seek(time);
        } else {
          this.resolution720p.seek(time);
        }
      } else {
        this.resolution960p.seek(time);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          resolution720p = _props.resolution720p,
          resolution960p = _props.resolution960p,
          resolution1080p = _props.resolution1080p,
          viewport = _props.viewport,
          restProps = _objectWithoutProperties(_props, ['playing', 'resolution720p', 'resolution960p', 'resolution1080p', 'viewport']);

      if (!resolution720p) {
        throw new Error('Missing `resolution720p` property');
      }

      if (!resolution960p) {
        throw new Error('Missing `resolution960p` property');
      }

      if (!resolution1080p) {
        throw new Error('Missing `resolution1080p` property');
      }

      var isValidViewport = viewport.width > -1 && viewport.height > -1;
      var isHorizontal = viewport.width / viewport.height >= THRESHOLD_HORIZONTAL;
      var is1080p = isHorizontal && viewport.width >= THRESHOLD_1080P;
      var className = '' + Object(__WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__["a" /* bem */])(style.smartVideo, {
        '1080p': is1080p,
        horizontal: isHorizontal
      }) + (this.props.className ? ' ' + this.props.className : '');
      return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('div', {
        className: className
      }, Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__Video__["a" /* default */], _extends({}, resolution720p, restProps, {
        className: style.smartVideo__720p,
        playing: isValidViewport && isHorizontal && !is1080p && playing,
        onTimeupdate: this.handleTimeupdate,
        ref: function ref(resolution720p) {
          return _this2.resolution720p = resolution720p;
        }
      })), Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__Video__["a" /* default */], _extends({}, resolution960p, restProps, {
        className: style.smartVideo__960p,
        playing: isValidViewport && !isHorizontal && !is1080p && playing,
        onTimeupdate: this.handleTimeupdate,
        ref: function ref(resolution960p) {
          return _this2.resolution960p = resolution960p;
        }
      })), Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__Video__["a" /* default */], _extends({}, resolution1080p, restProps, {
        className: style.smartVideo__1080p,
        playing: isValidViewport && isHorizontal && is1080p && playing,
        onTimeupdate: this.handleTimeupdate,
        ref: function ref(resolution1080p) {
          return _this2.resolution1080p = resolution1080p;
        }
      })));
    }
  }]);

  return SmartVideo;
}(__WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (SmartVideo);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_warn__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Scrubber__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TogglePlayButton__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ToggleMuteButton__ = __webpack_require__(64);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h








var style = {
  'videoPlayer': 'dhfc-1_0_0-beta_26-videoPlayer',
  'videoPlayer__container': 'dhfc-1_0_0-beta_26-videoPlayer__container',
  'videoPlayer__caption': 'dhfc-1_0_0-beta_26-videoPlayer__caption',
  'videoPlayer__controls': 'dhfc-1_0_0-beta_26-videoPlayer__controls',
  'videoPlayer__togglePlayButton': 'dhfc-1_0_0-beta_26-videoPlayer__togglePlayButton',
  'videoPlayer__toggleMuteButton': 'dhfc-1_0_0-beta_26-videoPlayer__toggleMuteButton'
};

var VideoPlayer = function (_PureComponent) {
  _inherits(VideoPlayer, _PureComponent);

  function VideoPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VideoPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      caption: null,
      duration: 0,
      isPlaying: false,
      time: 0
    }, _this.handleUserTogglePlay = function () {
      _this.props.onUserTogglePlay();
    }, _this.handleUserToggleMute = function () {
      _this.props.onUserToggleMute();
    }, _this.handleScrubberPositionUpdate = function (position) {
      if (_this.video) {
        _this.video.seek(_this.state.duration * position);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_warn__["a" /* default */])('[@nrk/dh-feature-components] No video reference');
      }
    }, _this.handleCaptionCueEnter = function (caption) {
      _this.setState({
        caption: caption
      });
    }, _this.handleCaptionCueExit = function () {
      _this.setState({
        caption: null
      });
    }, _this.handleDurationChange = function (duration) {
      _this.setState({
        duration: duration
      });
    }, _this.handlePlay = function () {
      var onPlay = _this.props.onPlay;

      _this.setState({
        isPlaying: true
      });

      if (onPlay) {
        onPlay();
      }
    }, _this.handlePause = function () {
      var onPause = _this.props.onPause;

      _this.setState({
        isPlaying: false
      });

      if (onPause) {
        onPause();
      }
    }, _this.handleTimeupdate = function (time) {
      _this.setState({
        time: time
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VideoPlayer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          muted = _props.muted,
          playing = _props.playing,
          video = _props.video;
      var _state = this.state,
          caption = _state.caption,
          duration = _state.duration,
          isPlaying = _state.isPlaying,
          time = _state.time;

      if (!video.attributes) {
        throw new Error('The `video` property must be a virtual node');
      }

      var className = '' + style.videoPlayer + (this.props.className ? ' ' + this.props.className : '');
      video.attributes.muted = muted;
      video.attributes.playing = playing;
      video.attributes.playsInline = true;

      video.attributes.ref = function (video) {
        return _this2.video = video;
      };

      video.attributes.onPlay = this.handlePlay;
      video.attributes.onPause = this.handlePause;
      video.attributes.onCaptionCueEnter = this.handleCaptionCueEnter;
      video.attributes.onCaptionCueExit = this.handleCaptionCueExit;
      video.attributes.onDurationChange = this.handleDurationChange;
      video.attributes.onTimeupdate = this.handleTimeupdate;
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: className
      }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: style.videoPlayer__container
      }, video, caption && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: style.videoPlayer__caption,
        'aria-hidden': 'true'
      }, caption.text.split('\n').map(function (text, idx) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
          key: String(idx)
        }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('span', {
          dangerouslySetInnerHTML: {
            __html: text
          }
        }));
      })), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: style.videoPlayer__controls
      }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_4__TogglePlayButton__["a" /* default */], {
        className: style.videoPlayer__togglePlayButton,
        playing: isPlaying,
        onClick: this.handleUserTogglePlay
      }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__Scrubber__["a" /* default */], {
        time: time,
        duration: duration,
        onPositionUpdate: this.handleScrubberPositionUpdate
      }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_5__ToggleMuteButton__["a" /* default */], {
        className: style.videoPlayer__toggleMuteButton,
        muted: muted,
        onClick: this.handleUserToggleMute
      }))));
    }
  }]);

  return VideoPlayer;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (VideoPlayer);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn() {
  var _console;

  typeof window !== 'undefined' && console && console.warn && (_console = console).warn.apply(_console, arguments);
}

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h




var style = {
  'scrubber': 'dhfc-1_0_0-beta_26-scrubber',
  'scrubber__bgBar': 'dhfc-1_0_0-beta_26-scrubber__bgBar',
  'scrubber__bufferedBar': 'dhfc-1_0_0-beta_26-scrubber__bufferedBar',
  'scrubber__playedBar': 'dhfc-1_0_0-beta_26-scrubber__playedBar'
};

var Scrubber = function (_PureComponent) {
  _inherits(Scrubber, _PureComponent);

  function Scrubber() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Scrubber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scrubber.__proto__ || Object.getPrototypeOf(Scrubber)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      left: 0,
      width: 0,
      isScrubbing: false,
      position: null
    }, _this.handleKeyDown = function (evt) {
      var _this$props = _this.props,
          duration = _this$props.duration,
          time = _this$props.time,
          onPositionUpdate = _this$props.onPositionUpdate;

      if (onPositionUpdate) {
        var nextTime = time;

        switch (evt.key) {
          case 'ArrowLeft':
            nextTime -= 1;
            break;

          case 'ArrowRight':
            nextTime += 1;
            break;
        }

        onPositionUpdate(Math.max(Math.min(nextTime / duration, 1), 0));
      }
    }, _this.handleMouseDown = function (evt) {
      evt.preventDefault();

      _this.focus();

      _this.start(evt.pageX);

      _this.elm.addEventListener('mousemove', _this.handleMouseMove);

      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseMove = function (evt) {
      _this.move(evt.pageX);
    }, _this.handleMouseUp = function (evt) {
      _this.focus();

      _this.end();

      _this.elm.removeEventListener('mousemove', _this.handleMouseMove);

      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleResize = function () {
      var rect = _this.bgElm.getBoundingClientRect();

      _this.setState({
        left: Math.floor(rect.left),
        width: rect.width
      });
    }, _this.handleTouchStart = function (evt) {
      if (evt.touches.length === 1) {
        evt.preventDefault();

        _this.focus();

        _this.start(evt.touches[0].clientX);

        _this.elm.addEventListener('touchmove', _this.handleTouchMove);

        window.addEventListener('touchend', _this.handleTouchEnd);
      }
    }, _this.handleTouchMove = function (evt) {
      if (evt.touches.length === 1) {
        _this.move(evt.touches[0].clientX);
      }
    }, _this.handleTouchEnd = function (evt) {
      _this.focus();

      _this.end();

      _this.elm.removeEventListener('touchmove', _this.handleTouchMove);

      window.removeEventListener('touchend', _this.handleTouchEnd);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Scrubber, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onPositionUpdate) {
        this.elm.addEventListener('keydown', this.handleKeyDown);
        this.elm.addEventListener('mousedown', this.handleMouseDown);
        this.elm.addEventListener('touchstart', this.handleTouchStart);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onPositionUpdate) {
        this.elm.removeEventListener('keydown', this.handleKeyDown);
        this.elm.removeEventListener('mousedown', this.handleMouseDown);
        this.elm.removeEventListener('touchstart', this.handleTouchStart);
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.handleElm.focus();
    }
  }, {
    key: 'start',
    value: function start(clientX) {
      if (this.positionTimeout) {
        clearTimeout(this.positionTimeout);
      }

      this.setState({
        position: (clientX - this.state.left) / this.state.width,
        isScrubbing: true
      });
    }
  }, {
    key: 'move',
    value: function move(clientX) {
      this.setState({
        position: Math.max(Math.min((clientX - this.state.left) / this.state.width, 1), 0)
      });
    }
  }, {
    key: 'end',
    value: function end() {
      var _this2 = this;

      if (this.props.onPositionUpdate && this.state.position !== null) {
        this.props.onPositionUpdate(this.state.position);
      }

      this.setState({
        isScrubbing: false
      });
      this.positionTimeout = setTimeout(function () {
        _this2.setState({
          position: null
        });
      }, 350);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          duration = _props.duration,
          time = _props.time;
      var className = '' + style.scrubber + (this.props.className ? ' ' + this.props.className : '');
      var position = this.state.position !== null ? this.state.position : time / duration;
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: className,
        ref: function ref(elm) {
          return _this3.elm = elm;
        }
      }, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: style.scrubber__bgBar,
        ref: function ref(bgElm) {
          return _this3.bgElm = bgElm;
        }
      }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: style.scrubber__bufferedBar
      }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', {
        className: style.scrubber__playedBar,
        style: {
          width: position * 100 + '%'
        }
      }), Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('button', {
        ref: function ref(handleElm) {
          return _this3.handleElm = handleElm;
        },
        role: 'slider',
        'aria-valuemin': '0',
        'aria-valuemax': duration * 1000,
        'aria-valuenow': time * 1000,
        style: {
          left: position * 100 + '%'
        }
      }));
    }
  }]);

  return Scrubber;
}(__WEBPACK_IMPORTED_MODULE_1__lib_preact_pure_component__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Scrubber);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TogglePlayButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
//  @jsx h


var style = {
  'togglePlayButton': 'dhfc-1_0_0-beta_26-togglePlayButton',
  'togglePlayButton__pauseIcon': 'dhfc-1_0_0-beta_26-togglePlayButton__pauseIcon',
  'togglePlayButton--playing': 'dhfc-1_0_0-beta_26-togglePlayButton--playing',
  'togglePlayButton__playIcon': 'dhfc-1_0_0-beta_26-togglePlayButton__playIcon'
};
function TogglePlayButton(props) {
  var playing = props.playing;
  var className = '' + Object(__WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__["a" /* bem */])(style.togglePlayButton, playing && 'playing') + (props.className ? ' ' + props.className : '');
  return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('button', {
    className: className,
    onClick: props.onClick
  }, Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('span', {
    className: 'nrk-sr'
  }, playing ? 'Sett video på pause' : 'Spill av video'), Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('svg', {
    className: style.togglePlayButton__pauseIcon,
    'aria-hidden': 'true',
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-media-pause" />'
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('svg', {
    className: style.togglePlayButton__playIcon,
    'aria-hidden': 'true',
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-media-play" />'
    }
  }));
}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ToggleMuteButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
//  @jsx h


var style = {
  'toggleMuteButton': 'dhfc-1_0_0-beta_26-toggleMuteButton',
  'toggleMuteButton__volumeIcon': 'dhfc-1_0_0-beta_26-toggleMuteButton__volumeIcon',
  'toggleMuteButton--muted': 'dhfc-1_0_0-beta_26-toggleMuteButton--muted',
  'toggleMuteButton__mutedIcon': 'dhfc-1_0_0-beta_26-toggleMuteButton__mutedIcon'
};
function ToggleMuteButton(props) {
  var muted = props.muted;
  var className = '' + Object(__WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__["a" /* bem */])(style.toggleMuteButton, muted && 'muted') + (props.className ? ' ' + props.className : '');
  return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('button', {
    className: className,
    onClick: props.onClick
  }, Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('span', {
    className: 'nrk-sr'
  }, muted ? 'Slå på lyd' : 'Slå av lyd'), Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('svg', {
    className: style.toggleMuteButton__mutedIcon,
    'aria-hidden': 'true',
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-media-volume--muted" />'
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('svg', {
    className: style.toggleMuteButton__volumeIcon,
    'aria-hidden': 'true',
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#nrk-media-volume--3" />'
    }
  }));
}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__ = __webpack_require__(1);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //  @jsx h






var ViewportIntersections = function (_PureComponent) {
  _inherits(ViewportIntersections, _PureComponent);

  function ViewportIntersections(props) {
    _classCallCheck(this, ViewportIntersections);

    var _this = _possibleConstructorReturn(this, (ViewportIntersections.__proto__ || Object.getPrototypeOf(ViewportIntersections)).call(this));

    _this.state = {
      intersections: props.children.map(function (child, idx) {
        return {
          isIntersecting: false,
          ratio: null
        };
      })
    };
    return _this;
  }

  _createClass(ViewportIntersections, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          onChange = _props.onChange,
          onEnter = _props.onEnter,
          onLeave = _props.onLeave,
          rootMargin = _props.rootMargin,
          threshold = _props.threshold;
      var childNodes = Object(__WEBPACK_IMPORTED_MODULE_0__nrk_dh_utils__["c" /* toArray */])(this.elm.childNodes);
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        var intersections = _this2.state.intersections.slice(0);

        entries.forEach(function (entry) {
          var idx = childNodes.indexOf(entry.target);
          var prevIntersection = intersections[idx];
          intersections.splice(idx, 1, {
            isIntersecting: entry.isIntersecting,
            ratio: entry.intersectionRatio
          });

          if (onEnter && !prevIntersection.isIntersecting && entry.isIntersecting) {
            onEnter(entry, idx);
          }

          if (onLeave && prevIntersection.isIntersecting && !entry.isIntersecting) {
            onLeave(entry, idx);
          }
        });

        _this2.setState({
          intersections: intersections
        });

        if (onChange) {
          onChange(intersections);
        }
      }, {
        rootMargin: rootMargin || '0px 0px 0px 0px',
        threshold: threshold || 1.0
      });
      childNodes.forEach(function (childElm) {
        return _this2.intersectionObserver.observe(childElm);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.intersectionObserver.disconnect();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          className = _props2.className,
          children = _props2.children,
          style = _props2.style;
      return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('div', {
        ref: function ref(elm) {
          return _this3.elm = elm;
        },
        className: className,
        style: style
      }, children);
    }
  }]);

  return ViewportIntersections;
}(__WEBPACK_IMPORTED_MODULE_2__lib_preact_pure_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (ViewportIntersections);

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ingress__title":"dh-stille-spesial-ingress__title","ingress__wrapper":"dh-stille-spesial-ingress__wrapper","ingress__paragraph":"dh-stille-spesial-ingress__paragraph"};

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MaxViewportRect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nrk_max_viewport_observable__ = __webpack_require__(68);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var h = __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */];
var MaxViewportRect =
/*#__PURE__*/
function (_Component) {
  _inherits(MaxViewportRect, _Component);

  function MaxViewportRect() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MaxViewportRect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MaxViewportRect)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dispose", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "el", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "viewport$", void 0);

    return _this;
  }

  _createClass(MaxViewportRect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.viewport$ = __WEBPACK_IMPORTED_MODULE_1__nrk_max_viewport_observable__["a" /* default */].create({
        root: this.el
      });
      this.dispose = this.viewport$.subscribe({
        next: function next(viewport) {
          _this2.props.onViewportChange(viewport.height);
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.dispose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var inlineStyle = {
        height: "100vh",
        width: '1vw',
        position: 'absolute'
      };
      return h("div", {
        ref: function ref(el) {
          return _this3.el = el;
        },
        style: inlineStyle
      });
    }
  }]);

  return MaxViewportRect;
}(Component);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
function create() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var root = opts.root;

  var getRect = function getRect() {
    if (root instanceof Element) {
      var rect = root.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height
      };
    }

    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  };

  var subscribe = function subscribe(observer) {
    var isDynamicViewport = false;
    var isTouching = false;
    var rect = {
      width: -1,
      height: -1
    };
    var listeners = {
      orientationchange: function orientationchange() {
        rect = {
          width: -1,
          height: -1
        };
      },
      resize: function resize() {
        var prevRect = rect;
        rect = getRect();

        if (isDynamicViewport && rect.height < prevRect.height) {
          rect.height = prevRect.height;
        }

        observer.next(rect);
      },
      scroll: function scroll() {
        if (isTouching) {
          isDynamicViewport = true;
          window.removeEventListener('scroll', listeners.scroll);
        }
      },
      touchstart: function touchstart() {
        isTouching = true;
      },
      touchend: function touchend() {
        isTouching = false;
      }
    };
    window.addEventListener('orientationchange', listeners.orientationchange);
    window.addEventListener('resize', listeners.resize);
    window.addEventListener('scroll', listeners.scroll);
    window.addEventListener('touchstart', listeners.touchstart);
    window.addEventListener('touchend', listeners.touchend); // Trigger initial "resize"

    listeners.resize();
    return {
      unsubscribe: function unsubscribe() {
        window.removeEventListener('orientationchange', listeners.orientationchange);
        window.removeEventListener('resize', listeners.resize);
        window.removeEventListener('scroll', listeners.scroll);
        window.removeEventListener('touchstart', listeners.touchstart);
        window.removeEventListener('touchend', listeners.touchend);
      }
    };
  };

  return {
    subscribe: subscribe
  };
}

var index = {
  create: create
};

/* harmony default export */ __webpack_exports__["a"] = (index);

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"dh-stille-spesial-header","header__content":"dh-stille-spesial-header__content","titleWrapper":"dh-stille-spesial-titleWrapper"};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Body; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);


var h = __WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */];
var Body = function Body(_ref) {
  var children = _ref.children;
  return h("div", {
    class: __WEBPACK_IMPORTED_MODULE_0__index_css__["body__wrapper"]
  }, children);
};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_ESI__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Byline__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Share__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact__ = __webpack_require__(0);





var h = __WEBPACK_IMPORTED_MODULE_4_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_4_preact__["a" /* Component */];
var Footer = function Footer() {
  return h("div", null, h("div", {
    className: __WEBPACK_IMPORTED_MODULE_1__index_css___default.a.published
  }, "Publisert: 04.11.2018"), h(__WEBPACK_IMPORTED_MODULE_2__Byline__["a" /* Byline */], null), h(__WEBPACK_IMPORTED_MODULE_3__Share__["a" /* Share */], null), h("div", {
    className: __WEBPACK_IMPORTED_MODULE_1__index_css___default.a.footer
  }, h(__WEBPACK_IMPORTED_MODULE_0__lib_ESI__["a" /* EsiInclude */], {
    path: "https://www.nrk.no/serum/render?id=1.12592700"
  })));
};

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"dh-stille-spesial-footer","published":"dh-stille-spesial-published"};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Byline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);


var h = __WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */];
var Byline = function Byline() {
  return h("div", {
    className: __WEBPACK_IMPORTED_MODULE_0__index_css___default.a.bylinewrapper
  }, h("span", {
    className: __WEBPACK_IMPORTED_MODULE_0__index_css___default.a.bylinetext
  }, "Foto: ", h("i", null, "Christian Nicolai Bj\xF8rke"), h("br", null), "Illustrasjon: ", h("i", null, "Marco Vaglieri"), h("br", null), " Digital historieutvikling:", ' ', h("i", null, "Susanne Stubberud Rom, Annichen Woll Eide,", ' ', h("span", {
    className: __WEBPACK_IMPORTED_MODULE_0__index_css___default.a.nowrap
  }, "Sjur Seibt"), ", Ragnar Aasen Rognstad")));
};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bylinewrapper":"dh-stille-spesial-bylinewrapper","nowrap":"dh-stille-spesial-nowrap","bylinetext":"dh-stille-spesial-bylinetext"};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Share; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);


var h = __WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */];
var Share = function Share() {
  return h("div", {
    className: "nrkno-share nrkno-no-print ".concat(__WEBPACK_IMPORTED_MODULE_0__index_css___default.a['sharewrapper']),
    "data-share-url": "https://www.nrk.no/stille-i-stormen-1.14264682"
  }, h("a", {
    class: "nrk-button nrk-button--o",
    "data-share": "Article:Facebook",
    rel: "noopener",
    target: "_blank",
    href: "https://www.facebook.com/sharer.php?u=https%3A%2F%2Fwww.nrk.no%2Fstille-i-stormen-1.14264682"
  }, h("span", {
    class: "nrk-sr"
  }, "Del p\xE5 Facebook"), h("svg", {
    viewBox: "0 0 15 15"
  }, h("title", null, "Del p\xE5 Facebook"), h("path", {
    d: "M8.4 4.6c0-.5 0-.8.8-.8h1V2H8.7C7 2 6.2 3.2 6.2 4.6v1H4.7v2h1.5V13h2.2V7.5H10l.2-1.8H8.4v-1z"
  }))), h("a", {
    class: "nrk-button nrk-button--o",
    "data-share": "Article:Twitter",
    rel: "noopener",
    target: "_blank",
    href: "https://twitter.com/intent/tweet?url=https%3A%2F%2Fwww.nrk.no%2Fstille-i-stormen-1.14264682&text=Stille%20i%20Stormen"
  }, h("span", {
    class: "nrk-sr"
  }, "Del p\xE5 Twitter"), h("svg", {
    viewBox: "0 0 15 15"
  }, h("title", null, "Del p\xE5 Twitter"), h("path", {
    d: "M14 4c-.4.3-1 .4-1.4.5.5-.3 1-.8 1-1.3-.4.3-1 .4-1.5.6-.3-.5-1-.8-1.7-.8C9 3 7.8 4 7.8 5.4V6C6 5.7 4 5 3 3.3l-.3 1.2c0 1 .4 1.6 1 2-.3 0-.7 0-1-.3 0 1.2.8 2.2 2 2.4h-.7-.5c.4 1 1.3 1.7 2.3 1.7-.8.6-2 1-3 1H2c1 .7 2.4 1 3.8 1 4.5 0 7-3.6 7-6.7v-.3c.5-.4 1-.8 1.2-1.3"
  }))));
};

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sharewrapper":"dh-stille-spesial-sharewrapper"};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Part; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nrk_dh_feature_components__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_HTML__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nrk_dh_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_ESI__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_cx__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact__ = __webpack_require__(0);







var h = __WEBPACK_IMPORTED_MODULE_6_preact__["b" /* h */];
var Part = function Part(_ref) {
  var part = _ref.part;
  return h("div", {
    class: __WEBPACK_IMPORTED_MODULE_0__index_css___default.a.body
  }, part.map(function (item, idx) {
    switch (item.type) {
      case 'title':
        return h("div", {
          key: idx,
          class: Object(__WEBPACK_IMPORTED_MODULE_5__lib_cx__["a" /* cx */])('article-feature', __WEBPACK_IMPORTED_MODULE_0__index_css___default.a['body__header-wrapper'])
        }, h("h2", {
          class: __WEBPACK_IMPORTED_MODULE_0__index_css___default.a['body__h2']
        }, item.value));

      case 'subtitle':
        return h("div", {
          key: idx,
          class: Object(__WEBPACK_IMPORTED_MODULE_5__lib_cx__["a" /* cx */])('article-feature', __WEBPACK_IMPORTED_MODULE_0__index_css___default.a['body__header-wrapper'])
        }, h("h3", {
          class: __WEBPACK_IMPORTED_MODULE_0__index_css___default.a['body__h3']
        }, item.value.text));

      case 'paragraph':
        return h("div", {
          key: idx,
          class: Object(__WEBPACK_IMPORTED_MODULE_5__lib_cx__["a" /* cx */])('article-feature text-body', __WEBPACK_IMPORTED_MODULE_0__index_css___default.a['body__paragraph-wrapper'])
        }, item && item.value.map(getTextValue));

      case 'image':
        return h("div", {
          key: idx,
          class: Object(__WEBPACK_IMPORTED_MODULE_5__lib_cx__["a" /* cx */])('article-feature', __WEBPACK_IMPORTED_MODULE_0__index_css___default.a.body__image)
        }, h(__WEBPACK_IMPORTED_MODULE_4__lib_ESI__["a" /* EsiInclude */], {
          path: "https://www.nrk.no/serum/render?id=".concat(item.value.id)
        }));

      default:
        return null;
    }
  }));
};

function getTextValue(item) {
  switch (item.type) {
    case 'pray':
      return h(__WEBPACK_IMPORTED_MODULE_2__lib_HTML__["a" /* HTML */], {
        tag: "p",
        class: Object(__WEBPACK_IMPORTED_MODULE_3__nrk_dh_utils__["a" /* bem */])(__WEBPACK_IMPORTED_MODULE_0__index_css___default.a.body__paragraph, 'centered', 'spaced')
      }, item.value.map(function (value) {
        return value.value;
      }).join('<br>'));

    case 'qoute':
      return h("p", null, h(__WEBPACK_IMPORTED_MODULE_2__lib_HTML__["a" /* HTML */], {
        tag: "span"
      }, item.value));

    case 'qoute-italic':
      return h("p", null, h(__WEBPACK_IMPORTED_MODULE_2__lib_HTML__["a" /* HTML */], {
        tag: "em"
      }, item.value));

    case 'list':
      return h(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_feature_components__["a" /* List */], {
        type: "unordered"
      }, item.value.map(function (listItem) {
        return listItem.type === 'list-item' ? h(__WEBPACK_IMPORTED_MODULE_1__nrk_dh_feature_components__["b" /* ListItem */], null, listItem.value) : h("p", null, listItem.value);
      }));

    case 'facts':
      return h("div", {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_0__index_css___default.a['fact__box'])
      }, item.value.map(function (factItem) {
        return factItem.type === 'fact-item' ? h("li", null, factItem.value) : h("p", null, factItem.value);
      }));

    default:
      return h(__WEBPACK_IMPORTED_MODULE_2__lib_HTML__["a" /* HTML */], {
        tag: "p"
      }, item.value);
  }
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTML; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var h = __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */];
var HTML =
/*#__PURE__*/
function (_Component) {
  _inherits(HTML, _Component);

  function HTML() {
    _classCallCheck(this, HTML);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTML).apply(this, arguments));
  }

  _createClass(HTML, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          tag = _this$props.tag,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["tag", "children"]);

      return h(tag, Object.assign({}, {
        dangerouslySetInnerHTML: {
          __html: children
        }
      }, rest));
    }
  }]);

  return HTML;
}(Component);

_defineProperty(HTML, "defaultProps", {
  tag: 'div',
  children: []
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cx;
function cx() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(Boolean).join(' ');
}

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Kloster; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nrk_feature_tests__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wall__ = __webpack_require__(82);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var h = __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */],
    Component = __WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */];



var Kloster =
/*#__PURE__*/
function (_Component) {
  _inherits(Kloster, _Component);

  function Kloster() {
    var _this;

    _classCallCheck(this, Kloster);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Kloster).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "reducedMotion", Object(__WEBPACK_IMPORTED_MODULE_1__nrk_feature_tests__["a" /* testReducedMotion */])());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "wrapper", undefined);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "update", function () {
      if (_this.props.visible) {
        requestAnimationFrame(_this.update);

        var _this$wrapper$getBoun = _this.wrapper.getBoundingClientRect(),
            top = _this$wrapper$getBoun.top,
            bottom = _this$wrapper$getBoun.bottom,
            height = _this$wrapper$getBoun.height;

        var scrollPositionFromDocumentTop = window.pageYOffset + window.innerHeight;
        var imageBottomPositionFromDocumentTop = bottom + window.pageYOffset;
        var s = window.innerHeight - height;
        var offset;

        if (s > 350) {
          offset = 0;
        } else {
          offset = -(1 / 6) * s + 350;
        }

        var imagePosAboveMin = scrollPositionFromDocumentTop + offset >= imageBottomPositionFromDocumentTop;
        var imagePosBelowMax = top > -offset;
        var animate = imagePosAboveMin && imagePosBelowMax;

        if (animate) {
          var _percent = (1 - (top + offset) / (window.innerHeight + offset * 2 - height)) * 100;

          if (_percent !== _this.state.percent) {
            _this.setState({
              percent: _percent
            });
          }
        } else {
          if (top < 0 - offset) {
            _this.setState({
              percent: 100
            });
          } else {
            _this.setState({
              percent: 0
            });
          }
        }
      }
    });

    _this.state = {
      percent: 0
    };
    return _this;
  }

  _createClass(Kloster, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.visible) {
        requestAnimationFrame(this.update);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.visible !== this.props.visible) {
        this.update();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.reducedMotion) {
        return h("div", {
          className: __WEBPACK_IMPORTED_MODULE_2__index_css___default.a.parallax__wrapper
        }, h("div", {
          className: __WEBPACK_IMPORTED_MODULE_2__index_css___default.a['parallax-container'],
          ref: function ref(el) {
            return _this2.wrapper = el;
          }
        }, h("img", {
          alt: "Tegning av kloster med fengselsmur foran",
          className: __WEBPACK_IMPORTED_MODULE_2__index_css___default.a.layer,
          srcset: " https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/bg-400.jpg 400w, https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/bg-800.jpg 800w, https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/bg-1200.jpg 1200w",
          src: "https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/full.jpg"
        }), h(__WEBPACK_IMPORTED_MODULE_3__wall__["a" /* Wall */], {
          animate: this.state.percent > 26
        })));
      }

      return h("div", {
        className: __WEBPACK_IMPORTED_MODULE_2__index_css___default.a.parallax__wrapper
      }, h("div", {
        className: __WEBPACK_IMPORTED_MODULE_2__index_css___default.a['parallax-container'],
        ref: function ref(el) {
          return _this2.wrapper = el;
        }
      }, h("img", {
        className: __WEBPACK_IMPORTED_MODULE_2__index_css___default.a.bg,
        alt: "Tegning av kloster med fengselsmur foran",
        src: "https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/full.jpg"
      })));
    }
  }]);

  return Kloster;
}(Component);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export testEventPassiveListener */
/* unused harmony export testJs */
/* unused harmony export testObjectFit */
/* unused harmony export testPositionSticky */
/* unused harmony export testVideoAutoPlay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return testReducedMotion; });
var hasSupportCache = void 0;

function testEventPassiveListener(callback) {
  if (hasSupportCache !== undefined) {
    callback(hasSupportCache);
    return;
  }

  hasSupportCache = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        hasSupportCache = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}

  callback(hasSupportCache);
}

function testJs(callback) {
  callback(true);
}

function testJs$1(callback) {
  var el = document.createElement('img');
  callback(el.style.objectFit !== undefined);
}

function testPositionSticky(callback) {
  var el = document.createElement('a');
  el.style.cssText = 'position: sticky; position: -webkit-sticky; position: -ms-sticky;';
  callback(el.style.position.indexOf('sticky') !== -1);
}

var videoAutoPlayCache = null;

function testVideoAutoPlay(callback) {
  if (typeof window === 'undefined') {
    return callback(false);
  }

  if (videoAutoPlayCache !== null) {
    return callback(videoAutoPlayCache);
  }

  var videoElm = document.createElement('video');
  var isPlaying = false;
  videoElm.setAttribute('autoplay', '');
  videoElm.setAttribute('muted', '');
  videoElm.setAttribute('webkit-playsinline', 'webkit-playsinline');
  videoElm.setAttribute('playsinline', 'playsinline');

  try {
    if (videoElm.canPlayType('video/ogg')) {
      videoElm.src = 'data:video/ogg;base64,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';
    } else if (videoElm.canPlayType('video/mp4')) {
      videoElm.src = 'data:video/mp4;base64,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';
    } else {
      return callback(false);
    }
  } catch (_) {
    return callback(false);
  }

  videoElm.load();
  var playPromise = videoElm.play();

  if (playPromise) {
    playPromise.catch(function (e) {// Do nothing
    });
  }

  videoElm.oncanplay = function () {
    videoAutoPlayCache = isPlaying;
    callback(videoAutoPlayCache);
  };

  videoElm.onplay = function () {
    isPlaying = true;
  };
}

function testReducedMotion(callback) {
  if (typeof window === 'undefined') {
    if (callback) {
      callback(false);
    }

    return false;
  }

  var test = !!window.matchMedia && window.matchMedia('(prefers-reduced-motion)').matches;

  if (callback) {
    callback(test);
  }

  return test;
}

var index = {
  testEventPassiveListener: testEventPassiveListener,
  testJs: testJs,
  testObjectFit: testJs$1,
  testPositionSticky: testPositionSticky,
  testVideoAutoPlay: testVideoAutoPlay,
  testReducedMotion: testReducedMotion
};
/* unused harmony default export */ var _unused_webpack_default_export = (index);


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);


var h = __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */];

var Wall = function Wall(_ref) {
  var animate = _ref.animate;
  var className = "".concat(__WEBPACK_IMPORTED_MODULE_1__index_css___default.a.wall, " ").concat(animate ? __WEBPACK_IMPORTED_MODULE_1__index_css___default.a['wall--animate'] : null);
  return h("picture", {
    className: className
  }, h("source", {
    srcset: " https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-400.webp 400w, https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-800.webp 800w, https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-1200.webp 1200w",
    type: "image/webp"
  }), h("source", {
    srcset: " https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-400.png 400w, https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-800.png 800w, https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-1000.png 1000w",
    type: "image/png"
  }), h("img", {
    alt: "",
    className: className,
    srcset: " https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-400.png 400w, https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-800.png 800w, https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-1000.png 1000w"
  }));
};



/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : n(e["dh-analytics-utils"] = {});
}(this, function (e) {
  "use strict";

  function n() {
    return window.ga;
  }

  var t = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }

    return e;
  };

  e.createGoogleAnalyticsTracker = function (e) {
    var o = [],
        r = e.name,
        a = e.gaPropertyId,
        i = e.self,
        l = e.context;
    if (!(r && a && i && l)) throw new Error("Unable to create google analytics tracker. Please pass an object containing name, gaPropertyId, self and context to createGoogleAnalyticsTracker method");
    var c,
        s,
        d,
        u,
        f,
        g,
        p,
        y,
        w = (c = i.id, s = l.id, d = i.title, u = i.publishedDate, f = c === s, g = document.referrer, {
      dimension1: c ? "pp:" + c : null,
      dimension2: d || null,
      dimension3: u ? String(u.getFullYear()) : null,
      dimension4: u ? String(u.getMonth() + 1) : null,
      dimension5: u ? String(u.getDate()) : null,
      dimension6: g.replace(/^(https?:\/\/)?www./, "$1"),
      dimension7: g.replace(/^(https?:\/\/)/, "").replace(/^www./, ""),
      dimension10: f ? null : s ? "pp:" + s : null
    }),
        v = (p = o, y = !1, function (e, o, r, a, i) {
      if (!r.category || !r.action) throw new Error("Error sending event to google analytics: Event is missing mandatory fields category and/or action");
      n() ? (y || (function (e, n) {
        window.ga("create", {
          trackingId: n,
          cookieDomain: "auto",
          name: e
        }), window.ga(e + ".set", "anonymizeIp", !0);
      }(e, o), y = !0), window.ga(e + ".send", "event", function (e, n) {
        var o = {};
        e.hasOwnProperty("category") && (o.eventCategory = e.category), e.hasOwnProperty("action") && (o.eventAction = e.action), e.hasOwnProperty("label") && (o.eventLabel = e.label), e.hasOwnProperty("value") && (o.eventValue = e.value), o.nonInteraction = e.nonInteraction || !1;
        var r = t({}, n, e.fieldsObject);
        return t({}, o, r);
      }(r, a))) : p.push(r);
    }),
        m = setInterval(function () {
      if (n()) for (clearInterval(m); o.length;) {
        var e = o.shift();
        v(r, a, e, w);
      }
    }, 1e3);
    return {
      sendEvent: function sendEvent(e) {
        v(r, a, e, w);
      }
    };
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getContextId;
// @flow
var POLOPOLY_ID_REGEX = /[1-9]{1,2}\.\d+/g;
function getContextId(url) {
  return extractPolopolyIdFromString(url);
}

function extractPolopolyIdFromString(str) {
  var matches = str.match(POLOPOLY_ID_REGEX);

  if (matches && matches.length) {
    return matches[0];
  }

  return null;
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// v1-bundle-ade7082e6b5fc4050ed7.js